import React from "react";

function Icon({...restProps}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="563"
      height="508"
      viewBox="0 0 563 508"
      {...restProps}
    >
      <defs>
        <linearGradient
          id="yjrjtbntea"
          x1="30.288%"
          x2="58.238%"
          y1="29.759%"
          y2="74.587%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="21%" stopColor="#FA6B8B"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="84%" stopColor="#D842BB"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="upbcrhlf7c"
          x1="57.108%"
          x2="42.555%"
          y1="58.026%"
          y2="35.931%"
        >
          <stop offset="20%" stopColor="#A031DD"></stop>
          <stop offset="44%" stopColor="#8537E5"></stop>
          <stop offset="97%" stopColor="#4147F9"></stop>
          <stop offset="100%" stopColor="#3C48FA"></stop>
        </linearGradient>
        <linearGradient
          id="35iw9bzmld"
          x1="72.107%"
          x2="36.977%"
          y1="84.922%"
          y2="17.466%"
        >
          <stop offset="0%" stopColor="#3C48FA"></stop>
          <stop offset="66%" stopColor="#4486E6"></stop>
          <stop offset="100%" stopColor="#48A1DD"></stop>
        </linearGradient>
        <linearGradient
          id="9m9ilrenmm"
          x1="79.684%"
          x2="-21.409%"
          y1="45.308%"
          y2="67.149%"
        >
          <stop offset="0%" stopColor="#A031DD" stopOpacity="0"></stop>
          <stop offset="11%" stopColor="#AC32D9" stopOpacity="0.26"></stop>
          <stop offset="24%" stopColor="#B732D4" stopOpacity="0.52"></stop>
          <stop offset="35%" stopColor="#C032D1" stopOpacity="0.73"></stop>
          <stop offset="46%" stopColor="#C733CE" stopOpacity="0.88"></stop>
          <stop offset="55%" stopColor="#CB33CD" stopOpacity="0.97"></stop>
          <stop offset="61%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="9dj1bhxpkn"
          x1="47.178%"
          x2="51.123%"
          y1="37.691%"
          y2="20.576%"
        >
          <stop offset="0%" stopColor="#A031DD" stopOpacity="0"></stop>
          <stop offset="11%" stopColor="#AC32D9" stopOpacity="0.26"></stop>
          <stop offset="24%" stopColor="#B732D4" stopOpacity="0.52"></stop>
          <stop offset="35%" stopColor="#C032D1" stopOpacity="0.73"></stop>
          <stop offset="46%" stopColor="#C733CE" stopOpacity="0.88"></stop>
          <stop offset="55%" stopColor="#CB33CD" stopOpacity="0.97"></stop>
          <stop offset="61%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="z16ehz5xjo"
          x1="44.946%"
          x2="29.184%"
          y1="49.633%"
          y2="60.462%"
        >
          <stop offset="0%" stopColor="#A031DD" stopOpacity="0"></stop>
          <stop offset="11%" stopColor="#AC32D9" stopOpacity="0.26"></stop>
          <stop offset="24%" stopColor="#B732D4" stopOpacity="0.52"></stop>
          <stop offset="35%" stopColor="#C032D1" stopOpacity="0.73"></stop>
          <stop offset="46%" stopColor="#C733CE" stopOpacity="0.88"></stop>
          <stop offset="55%" stopColor="#CB33CD" stopOpacity="0.97"></stop>
          <stop offset="61%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="jzf78j9plq"
          x1="51.398%"
          x2="49.488%"
          y1="101.092%"
          y2="14.442%"
        >
          <stop offset="0%" stopColor="#3C48FA"></stop>
          <stop offset="66%" stopColor="#4486E6"></stop>
          <stop offset="100%" stopColor="#48A1DD"></stop>
        </linearGradient>
        <linearGradient
          id="sx5jwm3qfr"
          x1="45.37%"
          x2="51.883%"
          y1="131.839%"
          y2="17.852%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="1crmxy4oss"
          x1="44.221%"
          x2="52.784%"
          y1="141.542%"
          y2="16.702%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="llwcckrlkt"
          x1="41.302%"
          x2="53.22%"
          y1="130.477%"
          y2="19.612%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="11%" stopColor="#F87387"></stop>
          <stop offset="27%" stopColor="#E67890"></stop>
          <stop offset="45%" stopColor="#C87F9F"></stop>
          <stop offset="66%" stopColor="#9E8BB3"></stop>
          <stop offset="88%" stopColor="#6899CD"></stop>
          <stop offset="100%" stopColor="#48A1DD"></stop>
        </linearGradient>
        <linearGradient
          id="lnmycy4pex"
          x1="59.806%"
          x2="39.642%"
          y1="30.076%"
          y2="60.166%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="13%" stopColor="#C534CE"></stop>
          <stop offset="32%" stopColor="#B237D4"></stop>
          <stop offset="54%" stopColor="#933BDE"></stop>
          <stop offset="79%" stopColor="#6842EC"></stop>
          <stop offset="100%" stopColor="#3C48FA"></stop>
        </linearGradient>
        <linearGradient
          id="x2y08mub6C"
          x1=".451%"
          x2="100.401%"
          y1="49.732%"
          y2="49.732%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="7bqhg2l4aG"
          x1="29.991%"
          x2="87.964%"
          y1="37.47%"
          y2="59.057%"
        >
          <stop offset="0%" stopColor="#48A1DD"></stop>
          <stop offset="12%" stopColor="#6899CD"></stop>
          <stop offset="34%" stopColor="#9E8BB3"></stop>
          <stop offset="55%" stopColor="#C87F9F"></stop>
          <stop offset="73%" stopColor="#E67890"></stop>
          <stop offset="89%" stopColor="#F87387"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="rnx7lw8inI"
          x1="0%"
          x2="100%"
          y1="50.037%"
          y2="50.037%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="soag35xhlJ"
          x1="0%"
          x2="100.124%"
          y1="49.656%"
          y2="49.656%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="zt15f5jprL"
          x1="106.735%"
          x2="23.138%"
          y1="105.812%"
          y2="17.298%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="egkl9hxp6M"
          x1="18.39%"
          x2="86.13%"
          y1="282.52%"
          y2="-215.306%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="54%" stopColor="#BB43C4"></stop>
          <stop offset="80%" stopColor="#A031DD"></stop>
        </linearGradient>
        <linearGradient
          id="gqh88w40yN"
          x1="24.73%"
          x2="92.047%"
          y1="233.911%"
          y2="-259.656%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="54%" stopColor="#BB43C4"></stop>
          <stop offset="80%" stopColor="#A031DD"></stop>
        </linearGradient>
        <linearGradient
          id="hk0zjcrkmO"
          x1="81.792%"
          x2="57.255%"
          y1="141.266%"
          y2="45.285%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="fqhoc18haP"
          x1="55.886%"
          x2="40.546%"
          y1="115.741%"
          y2="-42.812%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="e42rd2x2oQ"
          x1="93.737%"
          x2="17.894%"
          y1="131.479%"
          y2="-30.329%"
        >
          <stop offset="20%" stopColor="#3C48FA"></stop>
          <stop offset="47%" stopColor="#4063F1"></stop>
          <stop offset="100%" stopColor="#48A1DD"></stop>
        </linearGradient>
        <linearGradient
          id="w0prqlfoeR"
          x1="81.188%"
          x2="25.46%"
          y1="70.528%"
          y2="31.333%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="s1mpuue5hS"
          x1="-.989%"
          x2="118.999%"
          y1="28.145%"
          y2="60.138%"
        >
          <stop offset="0%" stopColor="#A031DD"></stop>
          <stop offset="17%" stopColor="#9933DF"></stop>
          <stop offset="40%" stopColor="#8737E4"></stop>
          <stop offset="68%" stopColor="#693EED"></stop>
          <stop offset="98%" stopColor="#3F47F9"></stop>
          <stop offset="100%" stopColor="#3C48FA"></stop>
        </linearGradient>
        <linearGradient
          id="lrnnfx1maT"
          x1="1.428%"
          x2="109.951%"
          y1="25.139%"
          y2="65.575%"
        >
          <stop offset="0%" stopColor="#A031DD"></stop>
          <stop offset="17%" stopColor="#9933DF"></stop>
          <stop offset="40%" stopColor="#8737E4"></stop>
          <stop offset="68%" stopColor="#693EED"></stop>
          <stop offset="98%" stopColor="#3F47F9"></stop>
          <stop offset="100%" stopColor="#3C48FA"></stop>
        </linearGradient>
        <linearGradient
          id="syyb89gtpU"
          x1="90.893%"
          x2="36.045%"
          y1="67.144%"
          y2="35.011%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="21%" stopColor="#FA6B8B"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="84%" stopColor="#D842BB"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="gopwrs5vrW"
          x1=".648%"
          x2="100.11%"
          y1="51.312%"
          y2="51.312%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient id="or70i4chzX" x1="46%" x2="54%" y1="47%" y2="47%">
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="2yycwiypwY"
          x1="-1.196%"
          x2="100%"
          y1="48.74%"
          y2="48.74%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="q64tqavgyaa"
          x1="106.134%"
          x2="23.833%"
          y1="77.71%"
          y2="26.203%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="21%" stopColor="#FA6B8B"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="84%" stopColor="#D842BB"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="z16owvhjdab"
          x1="88.11%"
          x2="43.146%"
          y1="91.869%"
          y2="22.158%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="11%" stopColor="#F87387"></stop>
          <stop offset="27%" stopColor="#E67890"></stop>
          <stop offset="45%" stopColor="#C87F9F"></stop>
          <stop offset="66%" stopColor="#9E8BB3"></stop>
          <stop offset="88%" stopColor="#6899CD"></stop>
          <stop offset="100%" stopColor="#48A1DD"></stop>
        </linearGradient>
        <linearGradient
          id="54chqxnqdad"
          x1="100.674%"
          x2="25.347%"
          y1="67.971%"
          y2="43.661%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="11%" stopColor="#F87387"></stop>
          <stop offset="27%" stopColor="#E67890"></stop>
          <stop offset="45%" stopColor="#C87F9F"></stop>
          <stop offset="66%" stopColor="#9E8BB3"></stop>
          <stop offset="88%" stopColor="#6899CD"></stop>
          <stop offset="100%" stopColor="#48A1DD"></stop>
        </linearGradient>
        <linearGradient
          id="r4s05xelsaf"
          x1="-.001%"
          x2="99.939%"
          y1="49.991%"
          y2="49.991%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="3nm72vptyah"
          x1="-.019%"
          x2="100%"
          y1="50.029%"
          y2="50.029%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="iim6u07hoaj"
          x1="36.62%"
          x2="86.203%"
          y1="32.105%"
          y2="78.586%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="spe0p290sak"
          x1="-10.147%"
          x2="84.185%"
          y1="84.064%"
          y2="2.178%"
        >
          <stop offset="0%" stopColor="#A031DD"></stop>
          <stop offset="29%" stopColor="#A731DA"></stop>
          <stop offset="69%" stopColor="#B932D3"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="tmo43rcb6al"
          x1="-8.568%"
          x2="83.142%"
          y1="81.433%"
          y2="-6.516%"
        >
          <stop offset="0%" stopColor="#A031DD"></stop>
          <stop offset="29%" stopColor="#A731DA"></stop>
          <stop offset="69%" stopColor="#B932D3"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="9k3bfx6f4am"
          x1="-10.299%"
          x2="100%"
          y1="50.091%"
          y2="50.091%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="13%" stopColor="#EF5E9B"></stop>
          <stop offset="30%" stopColor="#E04BB0"></stop>
          <stop offset="48%" stopColor="#D53DC0"></stop>
          <stop offset="70%" stopColor="#CE35C9"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="yvykr6yzdan"
          x1="0%"
          x2="129.98%"
          y1="51.309%"
          y2="51.309%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="30%" stopColor="#CE35C9"></stop>
          <stop offset="52%" stopColor="#D53DC0"></stop>
          <stop offset="70%" stopColor="#E04BB0"></stop>
          <stop offset="87%" stopColor="#EF5E9B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient id="llem6ljmiao" x1="0%" x2="100%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="g4l42ovpfap"
          x1="-.072%"
          x2="100%"
          y1="50.24%"
          y2="50.24%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="6j1ex5blbaq"
          x1="0%"
          x2="100%"
          y1="50.073%"
          y2="50.073%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="jgqq409iear"
          x1="-3.312%"
          x2="105.096%"
          y1="49.938%"
          y2="49.938%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="4z9dxphwgas"
          x1="167.573%"
          x2="36.053%"
          y1="211.445%"
          y2="29.778%"
        >
          <stop offset="20%" stopColor="#A031DD"></stop>
          <stop offset="71%" stopColor="#BB32D3"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="3l3bu3gk9at"
          x1="156.241%"
          x2="24.977%"
          y1="197.34%"
          y2="15.458%"
        >
          <stop offset="20%" stopColor="#A031DD"></stop>
          <stop offset="71%" stopColor="#BB32D3"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="6gs09yuk1au"
          x1="65.415%"
          x2="28.649%"
          y1="78.465%"
          y2="12.022%"
        >
          <stop offset="0%" stopColor="#A031DD"></stop>
          <stop offset="41%" stopColor="#703CEB"></stop>
          <stop offset="80%" stopColor="#4A45F6"></stop>
          <stop offset="100%" stopColor="#3C48FA"></stop>
        </linearGradient>
        <linearGradient
          id="n5bi13t06aw"
          x1="10.137%"
          x2="83.003%"
          y1="68.545%"
          y2="35.798%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="21%" stopColor="#FA6B8B"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="84%" stopColor="#D842BB"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="0iodtgmpoax"
          x1="-1.626%"
          x2="89.555%"
          y1="55.633%"
          y2="46.046%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="21%" stopColor="#FA6B8B"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="84%" stopColor="#D842BB"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="spor5k4xnaz"
          x1="-.524%"
          x2="99.476%"
          y1="49.728%"
          y2="49.728%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="uvyyu8t1taA"
          x1="0%"
          x2="100%"
          y1="49.985%"
          y2="49.985%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient id="r5ubi9nf8aB" x1="0%" x2="100%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="gl2t1wjqzaC"
          x1="33.089%"
          x2="59.235%"
          y1="76.696%"
          y2="42.673%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="21%" stopColor="#FA6B8B"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="84%" stopColor="#D842BB"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="z7nb7udw1aD"
          x1=".005%"
          x2="100%"
          y1="49.988%"
          y2="49.988%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="21%" stopColor="#FA6B8B"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="84%" stopColor="#D842BB"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="0gbg1m6o8aF"
          x1="0%"
          x2="100%"
          y1="49.926%"
          y2="49.926%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="m2nn32twfaG"
          x1=".021%"
          x2="99.97%"
          y1="49.986%"
          y2="49.986%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="ycl9fn4soaI"
          x1="0%"
          x2="100%"
          y1="49.93%"
          y2="49.93%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="2vysxtpzcaJ"
          x1="72.978%"
          x2="-21.027%"
          y1=".414%"
          y2="149.051%"
        >
          <stop offset="0%" stopColor="#3C48FA"></stop>
          <stop offset="20%" stopColor="#4A45F6"></stop>
          <stop offset="59%" stopColor="#703CEB"></stop>
          <stop offset="100%" stopColor="#A031DD"></stop>
        </linearGradient>
        <linearGradient
          id="5vndsn3r6aL"
          x1="-18.517%"
          x2="131.852%"
          y1="76.599%"
          y2="9.552%"
        >
          <stop offset="0%" stopColor="#48A1DD"></stop>
          <stop offset="53%" stopColor="#4063F1"></stop>
          <stop offset="80%" stopColor="#3C48FA"></stop>
        </linearGradient>
        <linearGradient
          id="vxdvf9h53aQ"
          x1="-57.243%"
          x2="55.553%"
          y1="420.504%"
          y2="35.612%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="618mdo5l0aR"
          x1="-5.016%"
          x2="100.679%"
          y1="50.256%"
          y2="50.256%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="17%" stopColor="#F86D8A"></stop>
          <stop offset="41%" stopColor="#E6609B"></stop>
          <stop offset="70%" stopColor="#C84CB8"></stop>
          <stop offset="100%" stopColor="#A031DD"></stop>
        </linearGradient>
        <linearGradient
          id="sbiv9n0euaS"
          x1="-3.81%"
          x2="100.476%"
          y1="50.055%"
          y2="50.055%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="l6qv3091haU"
          x1="62.857%"
          x2="40.886%"
          y1="124.486%"
          y2="23.831%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="u02qy6rjqaV"
          x1="117.064%"
          x2="-23.936%"
          y1="-89.539%"
          y2="204.461%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="54%" stopColor="#BB43C4"></stop>
          <stop offset="80%" stopColor="#A031DD"></stop>
        </linearGradient>
        <linearGradient
          id="3ftk2b8omaW"
          x1="442.353%"
          x2="-816.471%"
          y1="-212.09%"
          y2="662.374%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="k1dz4jllsaX"
          x1="138.064%"
          x2="-2.936%"
          y1="-138.539%"
          y2="155.461%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="54%" stopColor="#BB43C4"></stop>
          <stop offset="80%" stopColor="#A031DD"></stop>
        </linearGradient>
        <linearGradient
          id="q0vbhi364aY"
          x1="340%"
          x2="-918.824%"
          y1="-142.83%"
          y2="731.633%"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="16%" stopColor="#D842BB"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="79%" stopColor="#FA6B8B"></stop>
          <stop offset="100%" stopColor="#FF7184"></stop>
        </linearGradient>
        <linearGradient
          id="omvj39h1xaZ"
          x1="2.1%"
          x2="117.007%"
          y1="60.275%"
          y2="17.043%"
        >
          <stop offset="0%" stopColor="#48A1DD"></stop>
          <stop offset="53%" stopColor="#4063F1"></stop>
          <stop offset="80%" stopColor="#3C48FA"></stop>
        </linearGradient>
        <linearGradient
          id="uq3e80iiobd"
          x1="14.79%"
          x2="58.414%"
          y1="93.351%"
          y2="34.848%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="21%" stopColor="#FA6B8B"></stop>
          <stop offset="50%" stopColor="#ED5C9D"></stop>
          <stop offset="84%" stopColor="#D842BB"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="cb0cgropzbe"
          x1="87.151%"
          x2="18.525%"
          y1="202.064%"
          y2="-79.248%"
        >
          <stop offset="0%" stopColor="#3C48FA"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="km2n4u2n8bf"
          x1="1217.378%"
          x2="-153.388%"
          y1="1437.431%"
          y2="-198.08%"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient
          id="vcbs4o9vibg"
          x1="137.024%"
          x2="11.014%"
          y1="-296.392%"
          y2="222.777%"
        >
          <stop offset="0%" stopColor="#3C48FA"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </linearGradient>
        <linearGradient id="pid0znbrmbh" x1="100%" x2="0%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#96F4FE"></stop>
          <stop offset="100%" stopColor="#00E9FF"></stop>
        </linearGradient>
        <linearGradient id="7t3nysg65bi" x1="100%" x2="0%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#FEBC24"></stop>
          <stop offset="100%" stopColor="#FF9738"></stop>
        </linearGradient>
        <linearGradient id="fcftaxk9rbj" x1="100%" x2="0%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#FF61FC"></stop>
          <stop offset="100%" stopColor="#FF21E3"></stop>
        </linearGradient>
        <linearGradient
          id="wme971wqpbk"
          x1="100%"
          x2="0%"
          y1="37.5%"
          y2="62.5%"
        >
          <stop offset="0%" stopColor="#4202A9"></stop>
          <stop offset="100%" stopColor="#36008A"></stop>
        </linearGradient>
        <linearGradient
          id="7s2d4m4ctbl"
          x1="65.759%"
          x2="34.241%"
          y1="0%"
          y2="100%"
        >
          <stop offset="0%" stopColor="#4202A9"></stop>
          <stop offset="100%" stopColor="#36008A"></stop>
        </linearGradient>
        <linearGradient
          id="9gknqpqa8bm"
          x1="64.789%"
          x2="35.211%"
          y1="0%"
          y2="100%"
        >
          <stop offset="0%" stopColor="#96F4FE"></stop>
          <stop offset="100%" stopColor="#00E9FF"></stop>
        </linearGradient>
        <linearGradient
          id="utgyokfzwbn"
          x1="64.789%"
          x2="35.211%"
          y1="0%"
          y2="100%"
        >
          <stop offset="0%" stopColor="#FF7F6E"></stop>
          <stop offset="100%" stopColor="#FE4F55"></stop>
        </linearGradient>
        <linearGradient id="fu9ir4ow3bo" x1="100%" x2="0%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#4202A9"></stop>
          <stop offset="100%" stopColor="#36008A"></stop>
        </linearGradient>
        <radialGradient
          id="ckm4hmumtb"
          cx="60.825%"
          cy="-51.412%"
          r="114.147%"
          fx="60.825%"
          fy="-51.412%"
          gradientTransform="matrix(.84377 -.52932 .53671 .83215 .371 .236)"
        >
          <stop offset="0%" stopColor="#3C48FA"></stop>
          <stop offset="9%" stopColor="#3F47F9" stopOpacity="0.97"></stop>
          <stop offset="22%" stopColor="#4646F7" stopOpacity="0.9"></stop>
          <stop offset="37%" stopColor="#5243F4" stopOpacity="0.78"></stop>
          <stop offset="54%" stopColor="#633FEF" stopOpacity="0.61"></stop>
          <stop offset="72%" stopColor="#793AE8" stopOpacity="0.39"></stop>
          <stop offset="91%" stopColor="#9334E1" stopOpacity="0.13"></stop>
          <stop offset="100%" stopColor="#A031DD" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="flvy37a9le"
          cx="35.252%"
          cy="11.174%"
          r="48.896%"
          fx="35.252%"
          fy="11.174%"
          gradientTransform="matrix(.84377 -.52941 .53671 .8323 -.005 .205)"
        >
          <stop offset="0%" stopColor="#48C2DD"></stop>
          <stop offset="10%" stopColor="#4BBEDD" stopOpacity="0.97"></stop>
          <stop offset="24%" stopColor="#52B2DD" stopOpacity="0.89"></stop>
          <stop offset="40%" stopColor="#5E9EDD" stopOpacity="0.75"></stop>
          <stop offset="58%" stopColor="#6F82DD" stopOpacity="0.56"></stop>
          <stop offset="78%" stopColor="#845FDD" stopOpacity="0.31"></stop>
          <stop offset="99%" stopColor="#9E34DD" stopOpacity="0.02"></stop>
          <stop offset="100%" stopColor="#A031DD" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="0qmki2fcff"
          cx="41.577%"
          cy="8.258%"
          r="48.042%"
          fx="41.577%"
          fy="8.258%"
          gradientTransform="scale(.92683 1) rotate(-32.46 .432 .026)"
        >
          <stop offset="0%" stopColor="#08E5DD"></stop>
          <stop offset="10%" stopColor="#0AE3DD" stopOpacity="0.97"></stop>
          <stop offset="23%" stopColor="#0FDEDD" stopOpacity="0.89"></stop>
          <stop offset="39%" stopColor="#17D5DD" stopOpacity="0.76"></stop>
          <stop offset="57%" stopColor="#23C8DD" stopOpacity="0.57"></stop>
          <stop offset="76%" stopColor="#32B8DD" stopOpacity="0.34"></stop>
          <stop offset="96%" stopColor="#44A5DD" stopOpacity="0.05"></stop>
          <stop offset="100%" stopColor="#48A1DD" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="6l4zopq9bg"
          cx="106.753%"
          cy="90.663%"
          r="92.196%"
          fx="106.753%"
          fy="90.663%"
          gradientTransform="scale(1 .96363) rotate(-32.46 1.126 .924)"
        >
          <stop offset="39%" stopColor="#C3C"></stop>
          <stop offset="45%" stopColor="#CB33CD" stopOpacity="0.97"></stop>
          <stop offset="54%" stopColor="#C733CE" stopOpacity="0.88"></stop>
          <stop offset="65%" stopColor="#C032D1" stopOpacity="0.73"></stop>
          <stop offset="76%" stopColor="#B732D4" stopOpacity="0.52"></stop>
          <stop offset="89%" stopColor="#AC32D9" stopOpacity="0.26"></stop>
          <stop offset="100%" stopColor="#A031DD" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="2sraq4156h"
          cx="-21.658%"
          cy="50.184%"
          r="95.132%"
          fx="-21.658%"
          fy="50.184%"
          gradientTransform="matrix(.8308 -.53671 .52846 .84377 -.302 -.038)"
        >
          <stop offset="1%" stopColor="#FF6A7F"></stop>
          <stop offset="10%" stopColor="#FD6981" stopOpacity="0.97"></stop>
          <stop offset="23%" stopColor="#F66488" stopOpacity="0.9"></stop>
          <stop offset="37%" stopColor="#EA5E93" stopOpacity="0.78"></stop>
          <stop offset="54%" stopColor="#DB54A3" stopOpacity="0.62"></stop>
          <stop offset="71%" stopColor="#C748B7" stopOpacity="0.41"></stop>
          <stop offset="90%" stopColor="#AE3ACF" stopOpacity="0.15"></stop>
          <stop offset="100%" stopColor="#A031DD" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="0d0qvrq57i"
          cx="61.707%"
          cy="2.038%"
          r="53.146%"
          fx="61.707%"
          fy="2.038%"
          gradientTransform="scale(.87107 1) rotate(-32.46 .663 -.136)"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="10%" stopColor="#C3C" stopOpacity="0.97"></stop>
          <stop offset="25%" stopColor="#C3C" stopOpacity="0.88"></stop>
          <stop offset="42%" stopColor="#C3C" stopOpacity="0.73"></stop>
          <stop offset="61%" stopColor="#C3C" stopOpacity="0.52"></stop>
          <stop offset="82%" stopColor="#C3C" stopOpacity="0.26"></stop>
          <stop offset="100%" stopColor="#C3C" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="fkuqwzcdbj"
          cx="119.621%"
          cy="95.496%"
          r="130.961%"
          fx="119.621%"
          fy="95.496%"
          gradientTransform="scale(.87107 1) rotate(-32.46 1.285 .65)"
        >
          <stop offset="0%" stopColor="#08E5DD"></stop>
          <stop offset="10%" stopColor="#0FE2DA" stopOpacity="0.97"></stop>
          <stop offset="23%" stopColor="#23D8D3" stopOpacity="0.89"></stop>
          <stop offset="39%" stopColor="#44C9C8" stopOpacity="0.76"></stop>
          <stop offset="57%" stopColor="#71B4B7" stopOpacity="0.57"></stop>
          <stop offset="76%" stopColor="#AB98A2" stopOpacity="0.34"></stop>
          <stop offset="96%" stopColor="#F17789" stopOpacity="0.05"></stop>
          <stop offset="100%" stopColor="#FF7184" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="pmlwknelqk"
          cx="-49.128%"
          cy="27.9%"
          r="106.927%"
          fx="-49.128%"
          fy="27.9%"
          gradientTransform="matrix(1 0 0 .91907 0 .023)"
        >
          <stop offset="0%" stopColor="#48C2DD"></stop>
          <stop offset="10%" stopColor="#4BBEDD" stopOpacity="0.97"></stop>
          <stop offset="24%" stopColor="#52B2DD" stopOpacity="0.89"></stop>
          <stop offset="40%" stopColor="#5E9EDD" stopOpacity="0.75"></stop>
          <stop offset="58%" stopColor="#6F82DD" stopOpacity="0.56"></stop>
          <stop offset="78%" stopColor="#845FDD" stopOpacity="0.31"></stop>
          <stop offset="99%" stopColor="#9E34DD" stopOpacity="0.02"></stop>
          <stop offset="100%" stopColor="#A031DD" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="qsfq0vx1zl"
          cx="37.105%"
          cy="-6.644%"
          r="66.437%"
          fx="37.105%"
          fy="-6.644%"
          gradientTransform="matrix(.84377 -.53474 .53671 .84066 .094 .188)"
        >
          <stop offset="46%" stopColor="#FF8773"></stop>
          <stop offset="51%" stopColor="#FF8673" stopOpacity="0.97"></stop>
          <stop offset="58%" stopColor="#FF8575" stopOpacity="0.9"></stop>
          <stop offset="66%" stopColor="#FF8277" stopOpacity="0.78"></stop>
          <stop offset="75%" stopColor="#FF7F79" stopOpacity="0.62"></stop>
          <stop offset="84%" stopColor="#FF7A7D" stopOpacity="0.41"></stop>
          <stop offset="94%" stopColor="#FF7481" stopOpacity="0.15"></stop>
          <stop offset="100%" stopColor="#FF7184" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="cgfxvn8z2p"
          cx="75.375%"
          cy="-10.505%"
          r="120.942%"
          fx="75.375%"
          fy="-10.505%"
          gradientTransform="matrix(.91103 0 0 1 .067 0)"
        >
          <stop offset="0%" stopColor="#FF7184"></stop>
          <stop offset="68%" stopColor="#BB43C4"></stop>
          <stop offset="100%" stopColor="#A031DD"></stop>
        </radialGradient>
        <radialGradient
          id="l3y2n1krlu"
          cx="56.933%"
          cy="-22.114%"
          r="111.697%"
          fx="56.933%"
          fy="-22.114%"
          gradientTransform="matrix(1 0 0 .61945 0 -.084)"
        >
          <stop offset="39%" stopColor="#A031DD"></stop>
          <stop offset="45%" stopColor="#A031DD" stopOpacity="0.97"></stop>
          <stop offset="53%" stopColor="#A031DD" stopOpacity="0.89"></stop>
          <stop offset="63%" stopColor="#A031DD" stopOpacity="0.75"></stop>
          <stop offset="74%" stopColor="#A031DD" stopOpacity="0.56"></stop>
          <stop offset="87%" stopColor="#A031DD" stopOpacity="0.31"></stop>
          <stop offset="99%" stopColor="#A031DD" stopOpacity="0.02"></stop>
          <stop offset="100%" stopColor="#A031DD" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="v1mhmn62qv"
          cx="-36.241%"
          cy="52.887%"
          r="105.695%"
          fx="-36.241%"
          fy="52.887%"
          gradientTransform="matrix(1 0 0 .61945 0 .201)"
        >
          <stop offset="0%" stopColor="#08E5DD"></stop>
          <stop offset="10%" stopColor="#0AE3DD" stopOpacity="0.97"></stop>
          <stop offset="23%" stopColor="#0FDEDD" stopOpacity="0.89"></stop>
          <stop offset="39%" stopColor="#17D5DD" stopOpacity="0.76"></stop>
          <stop offset="57%" stopColor="#23C8DD" stopOpacity="0.57"></stop>
          <stop offset="76%" stopColor="#32B8DD" stopOpacity="0.34"></stop>
          <stop offset="96%" stopColor="#44A5DD" stopOpacity="0.05"></stop>
          <stop offset="100%" stopColor="#48A1DD" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="86az9aixuy"
          cx="52.456%"
          cy="-27.326%"
          r="85.744%"
          fx="52.456%"
          fy="-27.326%"
          gradientTransform="matrix(.43855 0 0 1 .295 0)"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="10%" stopColor="#CE36C9" stopOpacity="0.96"></stop>
          <stop offset="26%" stopColor="#D43DC0" stopOpacity="0.84"></stop>
          <stop offset="47%" stopColor="#DE49B2" stopOpacity="0.64"></stop>
          <stop offset="71%" stopColor="#EC5A9F" stopOpacity="0.37"></stop>
          <stop offset="98%" stopColor="#FD6F86" stopOpacity="0.03"></stop>
          <stop offset="100%" stopColor="#FF7184" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="n3t0kqe41A"
          cx="35.12%"
          cy="131.746%"
          r="126.865%"
          fx="35.12%"
          fy="131.746%"
          gradientTransform="matrix(.43855 0 0 1 .197 0)"
        >
          <stop offset="0%" stopColor="#08E5DD"></stop>
          <stop offset="10%" stopColor="#0AE3DD" stopOpacity="0.97"></stop>
          <stop offset="23%" stopColor="#0FDEDD" stopOpacity="0.89"></stop>
          <stop offset="39%" stopColor="#17D5DD" stopOpacity="0.76"></stop>
          <stop offset="57%" stopColor="#23C8DD" stopOpacity="0.57"></stop>
          <stop offset="76%" stopColor="#32B8DD" stopOpacity="0.34"></stop>
          <stop offset="96%" stopColor="#44A5DD" stopOpacity="0.05"></stop>
          <stop offset="100%" stopColor="#48A1DD" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="awsrcvmf6B"
          cx="81.623%"
          cy="100.568%"
          r="200.9%"
          fx="81.623%"
          fy="100.568%"
          gradientTransform="matrix(1 0 0 .95032 0 .05)"
        >
          <stop offset="1%" stopColor="#FF7184"></stop>
          <stop offset="16%" stopColor="#FF8B9B"></stop>
          <stop offset="34%" stopColor="#FFA3AF"></stop>
          <stop offset="53%" stopColor="#FFB4BE"></stop>
          <stop offset="74%" stopColor="#FFBEC6"></stop>
          <stop offset="100%" stopColor="#FFC1C9"></stop>
        </radialGradient>
        <radialGradient
          id="3qjmtdcvtD"
          cx="-31.182%"
          cy="182.625%"
          r="322.559%"
          fx="-31.182%"
          fy="182.625%"
          gradientTransform="matrix(.76846 0 0 1 -.072 0)"
        >
          <stop offset="1%" stopColor="#FF7184"></stop>
          <stop offset="16%" stopColor="#FF8B9B"></stop>
          <stop offset="34%" stopColor="#FFA3AF"></stop>
          <stop offset="53%" stopColor="#FFB4BE"></stop>
          <stop offset="74%" stopColor="#FFBEC6"></stop>
          <stop offset="100%" stopColor="#FFC1C9"></stop>
        </radialGradient>
        <radialGradient
          id="mtr81st5nE"
          cx="-9.673%"
          cy="159.293%"
          r="351.036%"
          fx="-9.673%"
          fy="159.293%"
          gradientTransform="matrix(.84081 0 0 1 -.015 0)"
        >
          <stop offset="1%" stopColor="#FF7184"></stop>
          <stop offset="16%" stopColor="#FF8B9B"></stop>
          <stop offset="34%" stopColor="#FFA3AF"></stop>
          <stop offset="53%" stopColor="#FFB4BE"></stop>
          <stop offset="74%" stopColor="#FFBEC6"></stop>
          <stop offset="100%" stopColor="#FFC1C9"></stop>
        </radialGradient>
        <radialGradient
          id="80bhqszbaF"
          cx="42.721%"
          cy="58.584%"
          r="84.66%"
          fx="42.721%"
          fy="58.584%"
          gradientTransform="matrix(.72715 0 0 1 .117 0)"
        >
          <stop offset="1%" stopColor="#FF7184"></stop>
          <stop offset="16%" stopColor="#FF8B9B"></stop>
          <stop offset="34%" stopColor="#FFA3AF"></stop>
          <stop offset="53%" stopColor="#FFB4BE"></stop>
          <stop offset="74%" stopColor="#FFBEC6"></stop>
          <stop offset="100%" stopColor="#FFC1C9"></stop>
        </radialGradient>
        <radialGradient
          id="rhu0motb4H"
          cx="-14.635%"
          cy="43.307%"
          r="103.66%"
          fx="-14.635%"
          fy="43.307%"
          gradientTransform="matrix(1 0 0 .6764 0 .14)"
        >
          <stop offset="0%" stopColor="#08E5DD"></stop>
          <stop offset="10%" stopColor="#0AE3DD" stopOpacity="0.97"></stop>
          <stop offset="23%" stopColor="#0FDEDD" stopOpacity="0.89"></stop>
          <stop offset="39%" stopColor="#17D5DD" stopOpacity="0.76"></stop>
          <stop offset="57%" stopColor="#23C8DD" stopOpacity="0.57"></stop>
          <stop offset="76%" stopColor="#32B8DD" stopOpacity="0.34"></stop>
          <stop offset="96%" stopColor="#44A5DD" stopOpacity="0.05"></stop>
          <stop offset="100%" stopColor="#48A1DD" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="8n048p2s4K"
          cx="80.322%"
          cy="86.677%"
          r="210.49%"
          fx="80.322%"
          fy="86.677%"
          gradientTransform="matrix(1 0 0 .59786 0 .349)"
        >
          <stop offset="1%" stopColor="#FF7184"></stop>
          <stop offset="16%" stopColor="#FF8B9B"></stop>
          <stop offset="34%" stopColor="#FFA3AF"></stop>
          <stop offset="53%" stopColor="#FFB4BE"></stop>
          <stop offset="74%" stopColor="#FFBEC6"></stop>
          <stop offset="100%" stopColor="#FFC1C9"></stop>
        </radialGradient>
        <radialGradient
          id="tg0nd2adrV"
          cx="-9.875%"
          cy="170.975%"
          r="386.016%"
          fx="-9.875%"
          fy="170.975%"
          gradientTransform="matrix(.71442 0 0 1 -.028 0)"
        >
          <stop offset="1%" stopColor="#FF7184"></stop>
          <stop offset="16%" stopColor="#FF8B9B"></stop>
          <stop offset="34%" stopColor="#FFA3AF"></stop>
          <stop offset="53%" stopColor="#FFB4BE"></stop>
          <stop offset="74%" stopColor="#FFBEC6"></stop>
          <stop offset="100%" stopColor="#FFC1C9"></stop>
        </radialGradient>
        <radialGradient
          id="97qy3ryvkZ"
          cx="124.21%"
          cy="98.35%"
          r="144.774%"
          fx="124.21%"
          fy="98.35%"
          gradientTransform="matrix(1 0 0 .7933 0 .203)"
        >
          <stop offset="1%" stopColor="#FF7184"></stop>
          <stop offset="16%" stopColor="#FF8B9B"></stop>
          <stop offset="34%" stopColor="#FFA3AF"></stop>
          <stop offset="53%" stopColor="#FFB4BE"></stop>
          <stop offset="74%" stopColor="#FFBEC6"></stop>
          <stop offset="100%" stopColor="#FFC1C9"></stop>
        </radialGradient>
        <radialGradient
          id="psjta23mzac"
          cx="41.423%"
          cy="71.34%"
          r="217.196%"
          fx="41.423%"
          fy="71.34%"
          gradientTransform="matrix(1 0 0 .97255 0 .02)"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="10%" stopColor="#CE36C9" stopOpacity="0.96"></stop>
          <stop offset="26%" stopColor="#D43DC0" stopOpacity="0.84"></stop>
          <stop offset="47%" stopColor="#DE49B2" stopOpacity="0.64"></stop>
          <stop offset="71%" stopColor="#EC5A9F" stopOpacity="0.37"></stop>
          <stop offset="98%" stopColor="#FD6F86" stopOpacity="0.03"></stop>
          <stop offset="100%" stopColor="#FF7184" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="0jion7hq5ae"
          cx="21.3%"
          cy="99.901%"
          r="149.759%"
          fx="21.3%"
          fy="99.901%"
          gradientTransform="matrix(.49816 0 0 1 .107 0)"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="10%" stopColor="#CE36C9" stopOpacity="0.96"></stop>
          <stop offset="26%" stopColor="#D43DC0" stopOpacity="0.84"></stop>
          <stop offset="47%" stopColor="#DE49B2" stopOpacity="0.64"></stop>
          <stop offset="71%" stopColor="#EC5A9F" stopOpacity="0.37"></stop>
          <stop offset="98%" stopColor="#FD6F86" stopOpacity="0.03"></stop>
          <stop offset="100%" stopColor="#FF7184" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="on5jnuw8kag"
          cx="62.408%"
          cy="110.213%"
          r="152.109%"
          fx="62.408%"
          fy="110.213%"
          gradientTransform="matrix(1 0 0 .52395 0 .525)"
        >
          <stop offset="46%" stopColor="#FF8773"></stop>
          <stop offset="51%" stopColor="#FF8673" stopOpacity="0.97"></stop>
          <stop offset="58%" stopColor="#FF8575" stopOpacity="0.9"></stop>
          <stop offset="66%" stopColor="#FF8277" stopOpacity="0.78"></stop>
          <stop offset="75%" stopColor="#FF7F79" stopOpacity="0.62"></stop>
          <stop offset="84%" stopColor="#FF7A7D" stopOpacity="0.41"></stop>
          <stop offset="94%" stopColor="#FF7481" stopOpacity="0.15"></stop>
          <stop offset="100%" stopColor="#FF7184" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="i61rvwfoaai"
          cx="15.468%"
          cy="115.648%"
          r="134.612%"
          fx="15.468%"
          fy="115.648%"
          gradientTransform="matrix(.27222 0 0 1 .113 0)"
        >
          <stop offset="46%" stopColor="#FF8773"></stop>
          <stop offset="51%" stopColor="#FF8673" stopOpacity="0.97"></stop>
          <stop offset="58%" stopColor="#FF8575" stopOpacity="0.9"></stop>
          <stop offset="66%" stopColor="#FF8277" stopOpacity="0.78"></stop>
          <stop offset="75%" stopColor="#FF7F79" stopOpacity="0.62"></stop>
          <stop offset="84%" stopColor="#FF7A7D" stopOpacity="0.41"></stop>
          <stop offset="94%" stopColor="#FF7481" stopOpacity="0.15"></stop>
          <stop offset="100%" stopColor="#FF7184" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="6wybi8ic7av"
          cx="-3.635%"
          cy="-25.107%"
          r="118.138%"
          fx="-3.635%"
          fy="-25.107%"
          gradientTransform="matrix(1 0 0 .74466 0 -.064)"
        >
          <stop offset="0%" stopColor="#08E5DD"></stop>
          <stop offset="10%" stopColor="#0AE3DD" stopOpacity="0.97"></stop>
          <stop offset="23%" stopColor="#0FDEDD" stopOpacity="0.89"></stop>
          <stop offset="39%" stopColor="#17D5DD" stopOpacity="0.76"></stop>
          <stop offset="57%" stopColor="#23C8DD" stopOpacity="0.57"></stop>
          <stop offset="76%" stopColor="#32B8DD" stopOpacity="0.34"></stop>
          <stop offset="96%" stopColor="#44A5DD" stopOpacity="0.05"></stop>
          <stop offset="100%" stopColor="#48A1DD" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="562rp3amnay"
          cx="44.914%"
          cy="110.143%"
          r="112.904%"
          fx="44.914%"
          fy="110.143%"
          gradientTransform="matrix(.6354 0 0 1 .164 0)"
        >
          <stop offset="0%" stopColor="#48C2DD"></stop>
          <stop offset="10%" stopColor="#4BBEDD" stopOpacity="0.97"></stop>
          <stop offset="24%" stopColor="#52B2DD" stopOpacity="0.89"></stop>
          <stop offset="40%" stopColor="#5E9EDD" stopOpacity="0.75"></stop>
          <stop offset="58%" stopColor="#6F82DD" stopOpacity="0.56"></stop>
          <stop offset="78%" stopColor="#845FDD" stopOpacity="0.31"></stop>
          <stop offset="99%" stopColor="#9E34DD" stopOpacity="0.02"></stop>
          <stop offset="100%" stopColor="#A031DD" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="25133il8faE"
          cx="48.512%"
          cy="-9.55%"
          r="56.757%"
          fx="48.512%"
          fy="-9.55%"
          gradientTransform="matrix(1 0 0 .71222 0 -.027)"
        >
          <stop offset="0%" stopColor="#48C2DD"></stop>
          <stop offset="10%" stopColor="#4BBEDD" stopOpacity="0.97"></stop>
          <stop offset="24%" stopColor="#52B2DD" stopOpacity="0.89"></stop>
          <stop offset="40%" stopColor="#5E9EDD" stopOpacity="0.75"></stop>
          <stop offset="58%" stopColor="#6F82DD" stopOpacity="0.56"></stop>
          <stop offset="78%" stopColor="#845FDD" stopOpacity="0.31"></stop>
          <stop offset="99%" stopColor="#9E34DD" stopOpacity="0.02"></stop>
          <stop offset="100%" stopColor="#A031DD" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="7s8m5yhkwaH"
          cx="-134.395%"
          cy="165.208%"
          r="278.839%"
          fx="-134.395%"
          fy="165.208%"
          gradientTransform="matrix(1 0 0 .86864 0 .217)"
        >
          <stop offset="46%" stopColor="#FF8773"></stop>
          <stop offset="51%" stopColor="#FF8673" stopOpacity="0.97"></stop>
          <stop offset="58%" stopColor="#FF8575" stopOpacity="0.9"></stop>
          <stop offset="66%" stopColor="#FF8277" stopOpacity="0.78"></stop>
          <stop offset="75%" stopColor="#FF7F79" stopOpacity="0.62"></stop>
          <stop offset="84%" stopColor="#FF7A7D" stopOpacity="0.41"></stop>
          <stop offset="94%" stopColor="#FF7481" stopOpacity="0.15"></stop>
          <stop offset="100%" stopColor="#FF7184" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="5dkb3db8haK"
          cx="33.821%"
          cy="68.207%"
          r="52.242%"
          fx="33.821%"
          fy="68.207%"
          gradientTransform="matrix(.91974 0 0 1 .027 0)"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="10%" stopColor="#CE36C9" stopOpacity="0.96"></stop>
          <stop offset="26%" stopColor="#D43DC0" stopOpacity="0.84"></stop>
          <stop offset="47%" stopColor="#DE49B2" stopOpacity="0.64"></stop>
          <stop offset="71%" stopColor="#EC5A9F" stopOpacity="0.37"></stop>
          <stop offset="98%" stopColor="#FD6F86" stopOpacity="0.03"></stop>
          <stop offset="100%" stopColor="#FF7184" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="6s1k6aompaM"
          cx="50.808%"
          cy="8.138%"
          r="97.141%"
          fx="50.808%"
          fy="8.138%"
          gradientTransform="matrix(.56246 0 0 1 .222 0)"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="10%" stopColor="#CE36C9" stopOpacity="0.96"></stop>
          <stop offset="26%" stopColor="#D43DC0" stopOpacity="0.84"></stop>
          <stop offset="47%" stopColor="#DE49B2" stopOpacity="0.64"></stop>
          <stop offset="71%" stopColor="#EC5A9F" stopOpacity="0.37"></stop>
          <stop offset="98%" stopColor="#FD6F86" stopOpacity="0.03"></stop>
          <stop offset="100%" stopColor="#FF7184" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="tm9mr36y8aN"
          cx="1.917%"
          cy="134.329%"
          r="204.434%"
          fx="1.917%"
          fy="134.329%"
          gradientTransform="matrix(1 0 0 .89187 0 .145)"
        >
          <stop offset="1%" stopColor="#FF7184"></stop>
          <stop offset="16%" stopColor="#FF8B9B"></stop>
          <stop offset="34%" stopColor="#FFA3AF"></stop>
          <stop offset="53%" stopColor="#FFB4BE"></stop>
          <stop offset="74%" stopColor="#FFBEC6"></stop>
          <stop offset="100%" stopColor="#FFC1C9"></stop>
        </radialGradient>
        <radialGradient
          id="o0x9qo4lbaO"
          cx="12.372%"
          cy="126.318%"
          r="350.842%"
          fx="12.372%"
          fy="126.318%"
          gradientTransform="matrix(1 0 0 .8951 0 .132)"
        >
          <stop offset="1%" stopColor="#FF7184"></stop>
          <stop offset="80%" stopColor="#D740BD"></stop>
          <stop offset="100%" stopColor="#C3C"></stop>
        </radialGradient>
        <radialGradient
          id="wapti065naP"
          cx="-131.631%"
          cy="-64.273%"
          r="270.078%"
          fx="-131.631%"
          fy="-64.273%"
          gradientTransform="matrix(1 0 0 .8951 0 -.067)"
        >
          <stop offset="0%" stopColor="#08E5DD"></stop>
          <stop offset="10%" stopColor="#0AE3DD" stopOpacity="0.97"></stop>
          <stop offset="23%" stopColor="#0FDEDD" stopOpacity="0.89"></stop>
          <stop offset="39%" stopColor="#17D5DD" stopOpacity="0.76"></stop>
          <stop offset="57%" stopColor="#23C8DD" stopOpacity="0.57"></stop>
          <stop offset="76%" stopColor="#32B8DD" stopOpacity="0.34"></stop>
          <stop offset="96%" stopColor="#44A5DD" stopOpacity="0.05"></stop>
          <stop offset="100%" stopColor="#48A1DD" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="lgdvii026aT"
          cx="21.543%"
          cy="98.689%"
          r="101.04%"
          fx="21.543%"
          fy="98.689%"
          gradientTransform="matrix(1 0 0 .97289 0 .027)"
        >
          <stop offset="1%" stopColor="#FF7184"></stop>
          <stop offset="16%" stopColor="#FF8B9B"></stop>
          <stop offset="34%" stopColor="#FFA3AF"></stop>
          <stop offset="53%" stopColor="#FFB4BE"></stop>
          <stop offset="74%" stopColor="#FFBEC6"></stop>
          <stop offset="100%" stopColor="#FFC1C9"></stop>
        </radialGradient>
        <radialGradient
          id="7eeifp8pxba"
          cx="53.412%"
          cy="-5.998%"
          r="113.138%"
          fx="53.412%"
          fy="-5.998%"
          gradientTransform="matrix(.54741 0 0 1 .242 0)"
        >
          <stop offset="0%" stopColor="#C3C"></stop>
          <stop offset="10%" stopColor="#CE36C9" stopOpacity="0.96"></stop>
          <stop offset="26%" stopColor="#D43DC0" stopOpacity="0.84"></stop>
          <stop offset="47%" stopColor="#DE49B2" stopOpacity="0.64"></stop>
          <stop offset="71%" stopColor="#EC5A9F" stopOpacity="0.37"></stop>
          <stop offset="98%" stopColor="#FD6F86" stopOpacity="0.03"></stop>
          <stop offset="100%" stopColor="#FF7184" stopOpacity="0"></stop>
        </radialGradient>
        <radialGradient
          id="r34u1wc62bb"
          cx="108.876%"
          cy="128.977%"
          r="236.361%"
          fx="108.876%"
          fy="128.977%"
          gradientTransform="matrix(1 0 0 .92092 0 .102)"
        >
          <stop offset="1%" stopColor="#FF7184"></stop>
          <stop offset="16%" stopColor="#FF8B9B"></stop>
          <stop offset="34%" stopColor="#FFA3AF"></stop>
          <stop offset="53%" stopColor="#FFB4BE"></stop>
          <stop offset="74%" stopColor="#FFBEC6"></stop>
          <stop offset="100%" stopColor="#FFC1C9"></stop>
        </radialGradient>
        <radialGradient
          id="1fryok3snbc"
          cx="97.827%"
          cy="203.786%"
          r="493.66%"
          fx="97.827%"
          fy="203.786%"
          gradientTransform="matrix(.9213 0 0 1 .077 0)"
        >
          <stop offset="1%" stopColor="#FF7184"></stop>
          <stop offset="16%" stopColor="#FF8B9B"></stop>
          <stop offset="34%" stopColor="#FFA3AF"></stop>
          <stop offset="53%" stopColor="#FFB4BE"></stop>
          <stop offset="74%" stopColor="#FFBEC6"></stop>
          <stop offset="100%" stopColor="#FFC1C9"></stop>
        </radialGradient>
        <path
          id="y15gl04qcw"
          d="M91.212 17.955c-9.223-3.083-20.53 2.645-32.984 1.123C31.283 15.77 17.992 1.18 17.992 1.18s-4.992-2.658-6.876 0C9.23 3.84.208 14.535.208 14.535s35.556 35.568 78.05 26.12c0 0 18.595 41.384 36.766 54.126 0 0 21.079-6.514 31.949-20.604a6.678 6.678 0 018.386-2.06c.643.354 1.225.81 1.723 1.349 0 0 7.712-6.577 4.343-11.557-3.37-4.98-26.046-11.843-32.261-29.553 0 0 40.822-15.275 75.753 8.2 0 0 2.072 3.245 5.916-.824 3.844-4.068 7.975-15.313 3.657-18.632-4.318-3.32-39.475-23.163-90.643-12.555 0 0-10.283 2.845-13.977-1.81l-18.658 11.22z"
        ></path>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="url(#yjrjtbntea)"
          fillRule="nonzero"
          d="M369.146 246.54a198.337 198.337 0 01-17.297-10.383 218.22 218.22 0 01-61.776-63.56l-.45-.712c-15.774-24.797-48.36-33.421-73.831-18.72-23.791 13.65-33.814 42.796-23.45 68.191a77.497 77.497 0 015.728 22.664l.15 1.66a10.77 10.77 0 01-14.577 11.007l-1.735-.674a11.024 11.024 0 01-4.867-3.744c-11.446-15.066-32.264-19.357-48.735-10.046-16.471 9.312-23.53 29.361-16.523 46.937a28.626 28.626 0 011.698 15.338 28.508 28.508 0 01-14.352 20.305l-34.87 19.17a66.794 66.794 0 00-7.026 3.868c-26.997 17.174-37.66 51.323-25.232 80.808 12.428 29.484 44.32 45.697 75.464 38.363 31.145-7.333 52.452-36.07 50.42-68.003-1.343-18.517 11.263-35.155 29.452-38.875l1.336-.262a36.71 36.71 0 0120.991 2.071l9.485 3.87a202.095 202.095 0 0157.558 36.291c34.508 30.543 86.23 31.04 121.32 1.167 35.089-29.873 42.85-81.012 18.206-119.952-9.81-15.537-36.292-30.938-47.087-36.778z"
        ></path>
        <path
          fill="url(#ckm4hmumtb)"
          fillRule="nonzero"
          d="M298.846 185.326a223.861 223.861 0 01-8.736-12.73l-.45-.71c-15.774-24.798-48.36-33.422-73.83-18.72-23.792 13.65-33.814 42.795-23.45 68.19a78.991 78.991 0 015.503 20.617c18.973 19.291 48.509 23.498 72.113 10.271s35.436-40.615 28.888-66.868l-.038-.05z"
        ></path>
        <path
          fill="url(#upbcrhlf7c)"
          fillRule="nonzero"
          d="M489.141 93.187c31.487-12.743 29.403-41.858 10.77-58.02-16.311-14.165-45.327-14.49-56.16 9.984-12.48 28.155 9.86 44.604-25.72 70.949-43.107 31.924-96.31 11.644-138.803 43.68-55.586 41.958-33.285 103.41-.337 119.945 52.416 26.295 75.117-71.21 137.342 3.557.661.786 84.465.5 43.306-109.574-20.742-55.499-7.638-65.433 29.602-80.521z"
        ></path>
        <path
          fill="url(#35iw9bzmld)"
          fillRule="nonzero"
          d="M373.24 113.591c.399 3.37 2.358 5.517 7.762 5.741 6.826.3 16.748-5.154 25.397-14.252 16.76-17.647 28.704-49.021 3.956-78.998a73.793 73.793 0 00-3.57-4.031c-12.754-13.541-39.698-13.728-54.088-.55-.3.263-.586.537-.873.824-13.416 13.341-16.224 32.136 8.91 46.438 24.1 13.628 11.307 34.732 12.505 44.828z"
        ></path>
        <path
          fill="url(#flvy37a9le)"
          fillRule="nonzero"
          d="M499.911 35.167c-11.057-9.597-27.942-12.83-41.059-6.315a57.38 57.38 0 00-4.168 2.496 32.963 32.963 0 00-10.933 13.728c-5.578 12.605-4.193 22.864-4.143 32.71a38.994 38.994 0 002.284 4.094 40.42 40.42 0 0030.688 18.632c4.83-2.496 10.346-4.842 16.561-7.363 31.487-12.705 29.403-41.82 10.77-57.982z"
        ></path>
        <path
          fill="url(#0qmki2fcff)"
          fillRule="nonzero"
          d="M409.793 24.035a291.622 291.622 0 00-2.221-2.496c-12.767-13.528-39.712-13.728-54.101-.55l-.861.824c-13.416 13.342-16.286 32.149 8.898 46.439a31.871 31.871 0 0110.234 8.736c.312 0 .636.087.96.112 4.83-2.496 10.347-4.842 16.562-7.35 24.448-9.947 28.616-29.79 20.53-45.715z"
        ></path>
        <path
          fill="url(#6l4zopq9bg)"
          fillRule="nonzero"
          d="M463.707 185.975c-20.947-20.738-53.74-23.498-77.859-6.554-24.119 16.945-32.641 48.73-20.234 75.469 14.277-1.96 30.339 4.118 50.594 28.467.636.686 78.125.424 47.499-97.382z"
        ></path>
        <path
          fill="url(#2sraq4156h)"
          fillRule="nonzero"
          d="M279.228 159.767c-55.586 41.958-33.285 103.41-.337 119.946 41.658 20.891 64.534-36.33 103.446-23.276a80.882 80.882 0 00-52.154-116.063c-17.734 2.77-35.118 7.45-50.955 19.393z"
        ></path>
        <path
          fill="url(#0d0qvrq57i)"
          fillRule="nonzero"
          d="M278.89 279.713c-16.66-8.362-30.588-28.205-33.109-51.168-38.914 33.311-51.747 88.002-31.712 135.146l5.08 2.071a202.142 202.142 0 0157.558 36.292c34.507 30.478 86.171 30.954 121.233 1.116 35.063-29.837 42.858-80.912 18.293-119.85-62.225-74.818-84.914 22.688-137.342-3.607z"
        ></path>
        <path
          fill="url(#fkuqwzcdbj)"
          fillRule="nonzero"
          d="M278.89 279.713c-16.66-8.362-30.588-28.205-33.109-51.168-38.914 33.311-51.747 88.002-31.712 135.146l5.08 2.071a202.142 202.142 0 0157.558 36.292c34.507 30.478 86.171 30.954 121.233 1.116 35.063-29.837 42.858-80.912 18.293-119.85-62.225-74.818-84.914 22.688-137.342-3.607z"
        ></path>
        <path
          fill="url(#pmlwknelqk)"
          fillRule="nonzero"
          d="M111.671 310.775a28.524 28.524 0 01-12.542 14.003l-34.87 19.194a66.984 66.984 0 00-7.026 3.869c-26.997 17.174-37.66 51.323-25.232 80.808 12.428 29.484 44.32 45.697 75.464 38.363 31.145-7.333 52.452-36.07 50.42-68.003a37.438 37.438 0 0114.164-31.874 81.92 81.92 0 00-60.378-56.36z"
        ></path>
        <path
          fill="url(#qsfq0vx1zl)"
          fillRule="nonzero"
          d="M111.783 289.123a29.031 29.031 0 012.06 9.834c12.496 17.219 36.179 21.846 54.237 10.597 18.06-11.249 24.348-34.545 14.403-53.354l-.6-.237a11.017 11.017 0 01-4.867-3.744c-11.446-15.066-32.264-19.357-48.735-10.046-16.471 9.312-23.53 29.361-16.523 46.937l.025.013z"
        ></path>
        <path
          fill="url(#yjrjtbntea)"
          fillRule="nonzero"
          d="M369.146 246.54a198.337 198.337 0 01-17.297-10.383 218.22 218.22 0 01-61.776-63.56l-.45-.712c-15.774-24.797-48.36-33.421-73.831-18.72-23.791 13.65-33.814 42.796-23.45 68.191a77.497 77.497 0 015.728 22.664l.15 1.66a10.77 10.77 0 01-14.577 11.007l-1.735-.674a11.024 11.024 0 01-4.867-3.744c-11.446-15.066-32.264-19.357-48.735-10.046-16.471 9.312-23.53 29.361-16.523 46.937a28.626 28.626 0 011.698 15.338 28.508 28.508 0 01-14.352 20.305l-34.87 19.17a66.794 66.794 0 00-7.026 3.868c-26.997 17.174-37.66 51.323-25.232 80.808 12.428 29.484 44.32 45.697 75.464 38.363 31.145-7.333 52.452-36.07 50.42-68.003-1.343-18.517 11.263-35.155 29.452-38.875l1.336-.262a36.71 36.71 0 0120.991 2.071l9.485 3.87a202.095 202.095 0 0157.558 36.291c34.508 30.543 86.23 31.04 121.32 1.167 35.089-29.873 42.85-81.012 18.206-119.952-9.81-15.537-36.292-30.938-47.087-36.778z"
        ></path>
        <path
          fill="url(#9m9ilrenmm)"
          fillRule="nonzero"
          d="M150.434 62.995s-10.271 2.858-13.965-1.797c0 0-3.145-7.051-3.395-12.905 0 .437 0 .874.1 1.323.075 0 15.45-7.188 12.705-24.96-1.822-11.73-14.415-8.61-18.858-12.105C122.978 9.356 121.88-3.112 109.75.745c-12.48 3.968-3.644 18.183-3.644 18.183l.799 2.371c.165.076.336.138.511.187a4.1 4.1 0 002.596-.137c.332-.13.647-.303.936-.512.262-.2.562-.411.886-.624a25.905 25.905 0 000 0c-.324.213-.624.425-.886.624-.29.21-.604.381-.936.512a4.1 4.1 0 01-2.596.137 3.433 3.433 0 01-.511-.187 18.284 18.284 0 00-1.498 2.297c-.121.157-.23.324-.324.499a31.19 31.19 0 00-3.108 9.06.923.923 0 00-.487.737c-.017.29.087.575.287.786-.51 3.73-.463 7.515.138 11.232 1.248 7.837 4.405 9.71 7.276 9.634a6.402 6.402 0 016.676 5.192l1.897 11.631c-9.222-3.082-20.53 2.646-32.997 1.111-26.932-3.295-40.223-17.884-40.223-17.884s-4.992-2.67-6.876 0c-1.248 1.735-5.48 6.852-8.3 10.221l8.3-10.22a44.163 44.163 0 01-6.128-7.376 4.29 4.29 0 00-.5-.662 77.689 77.689 0 01-9.559-20.505s-2.858-1.896-2.733 2.721c.125 4.618 3.744 14.003 3.744 14.003L8.5 37.199a1.609 1.609 0 00-1.747 2.658h.075c2.57 2.171 11.506 8.137 11.506 8.137L.948 49.317s-1.996 1.585 2.247 2.496c3.752.542 7.543.763 11.332.661l-8.362 5.08s.225 1.335 2.496.986a22.338 22.338 0 004.855-1.573s5.179 8.986 15.85 8.81l-2.609 3.12s35.556 35.569 78.05 26.11c0 0 18.595 41.395 36.754 54.137 0 0-21.279 20.505-26.208 29.079-4.93 8.573 5.116 19.543 8.736 23.312 4.817 4.717 2.915 3.58 8.335 7.59 3.408-2.948 16.595-14.005 39.563-33.174 7.9-7.038 15.837-15.113 19.057-21.603 7.288-14.639-1.41-24.26-7.376-26.482-.686-.25-1.185-1.023-1.997-1.473l.287.113c.642.355 1.22.815 1.71 1.36 0 0 7.725-6.577 4.356-11.569-3.37-4.992-26.046-11.831-32.261-29.54 0 0 45.851-34.37-5.33-23.762zm-19.094-26.42a1.252 1.252 0 01-.425-.55c.095.202.241.374.425.5v.05zm1.722 10.483v1.248a21.55 21.55 0 010-1.298v.05zm.112-1.248c0 .283-.025.57-.075.861.017-.341.042-.64.075-.899v.038zm.237-1.148c.295.022.591.022.886 0a5.828 5.828 0 01-.886-.038v.038zm-1.385-18.096a13.14 13.14 0 00-.001-.038v.038zm17.934 119.433l-1.423.624 1.423-.624zm20.305-13.54a60.447 60.447 0 01-2.421 2.283c.823-.798 1.634-1.56 2.42-2.346v.063zm-6.652 5.665c-.749.55-1.51 1.086-2.272 1.585.762-.561 1.523-1.098 2.272-1.647v.062zm-7.089 4.53c-.586.338-1.173.662-1.747.962.574-.362 1.16-.687 1.747-1.024v.063z"
          opacity="0.4"
          transform="translate(264.576 194.728)"
        ></path>
        <path
          fill="url(#ckm4hmumtb)"
          fillRule="nonzero"
          d="M298.846 185.326a223.861 223.861 0 01-8.736-12.73l-.45-.71c-15.774-24.798-48.36-33.422-73.83-18.72-23.792 13.65-33.814 42.795-23.45 68.19a78.991 78.991 0 015.503 20.617c18.973 19.291 48.509 23.498 72.113 10.271s35.436-40.615 28.888-66.868l-.038-.05z"
        ></path>
        <path
          fill="url(#upbcrhlf7c)"
          fillRule="nonzero"
          d="M489.141 93.187c31.487-12.743 29.403-41.858 10.77-58.02-16.311-14.165-45.327-14.49-56.16 9.984-12.48 28.155 9.86 44.604-25.72 70.949-43.107 31.924-96.31 11.644-138.803 43.68-55.586 41.958-33.285 103.41-.337 119.945 52.416 26.295 75.117-71.21 137.342 3.557.661.786 84.465.5 43.306-109.574-20.742-55.499-7.638-65.433 29.602-80.521z"
        ></path>
        <g fillRule="nonzero" opacity="0.4">
          <path
            fill="url(#9dj1bhxpkn)"
            d="M150.434 62.995s-10.271 2.858-13.965-1.797c0 0-3.145-7.051-3.395-12.905 0 .437 0 .874.1 1.323.075 0 15.45-7.188 12.705-24.96-1.822-11.73-14.415-8.61-18.858-12.105C122.978 9.356 121.88-3.112 109.75.745c-12.48 3.968-3.644 18.183-3.644 18.183l.799 2.371c.165.076.336.138.511.187a4.1 4.1 0 002.596-.137c.332-.13.647-.303.936-.512.262-.2.562-.411.886-.624a25.905 25.905 0 000 0c-.324.213-.624.425-.886.624-.29.21-.604.381-.936.512a4.1 4.1 0 01-2.596.137 3.433 3.433 0 01-.511-.187 18.284 18.284 0 00-1.498 2.297c-.121.157-.23.324-.324.499a31.19 31.19 0 00-3.108 9.06.923.923 0 00-.487.737c-.017.29.087.575.287.786-.51 3.73-.463 7.515.138 11.232 1.248 7.837 4.405 9.71 7.276 9.634a6.402 6.402 0 016.676 5.192l1.897 11.631c-9.222-3.082-20.53 2.646-32.997 1.111-26.932-3.295-40.223-17.884-40.223-17.884s-4.992-2.67-6.876 0c-1.248 1.735-5.48 6.852-8.3 10.221l8.3-10.22a44.163 44.163 0 01-6.128-7.376 4.29 4.29 0 00-.5-.662 77.689 77.689 0 01-9.559-20.505s-2.858-1.896-2.733 2.721c.125 4.618 3.744 14.003 3.744 14.003L8.5 37.199a1.609 1.609 0 00-1.747 2.658h.075c2.57 2.171 11.506 8.137 11.506 8.137L.948 49.317s-1.996 1.585 2.247 2.496c3.752.542 7.543.763 11.332.661l-8.362 5.08s.225 1.335 2.496.986a22.338 22.338 0 004.855-1.573s5.179 8.986 15.85 8.81l-2.609 3.12s35.556 35.569 78.05 26.11c0 0 18.595 41.395 36.754 54.137 0 0-21.279 20.505-26.208 29.079-4.93 8.573 5.116 19.543 8.736 23.312 4.817 4.717 2.915 3.58 8.335 7.59.5 4.33 13.688-6.728 39.563-33.174 7.9-7.038 15.837-15.113 19.057-21.603 7.288-14.639-1.41-24.26-7.376-26.482-.686-.25-1.185-1.023-1.997-1.473l.287.113c.642.355 1.22.815 1.71 1.36 0 0 7.725-6.577 4.356-11.569-3.37-4.992-26.046-11.831-32.261-29.54 0 0 45.851-34.37-5.33-23.762zm-19.094-26.42a1.252 1.252 0 01-.425-.55c.095.202.241.374.425.5v.05zm1.722 10.483v1.248a21.55 21.55 0 010-1.298v.05zm.112-1.248c0 .283-.025.57-.075.861.017-.341.042-.64.075-.899v.038zm.237-1.148c.295.022.591.022.886 0a5.828 5.828 0 01-.886-.038v.038zm-1.385-18.096a13.14 13.14 0 00-.001-.038v.038zm17.934 119.433l-1.423.624 1.423-.624zm20.305-13.54a60.447 60.447 0 01-2.421 2.283c.823-.798 1.634-1.56 2.42-2.346v.063zm-6.652 5.665c-.749.55-1.51 1.086-2.272 1.585.762-.561 1.523-1.098 2.272-1.647v.062zm-7.089 4.53c-.586.338-1.173.662-1.747.962.574-.362 1.16-.687 1.747-1.024v.063z"
            transform="translate(264.576 194.728)"
          ></path>
          <path
            fill="url(#z16ehz5xjo)"
            d="M82.015 1.446a30.564 30.564 0 00-9.335 0c-8.91 1.772-46.176 4.031-46.176 4.031-1.996 1.41-.262 9.335-.262 9.335l-3.507-1.522c-4.542-2.496-2.288-2.793-8.704-2.28-4.448.355-8.448 1.398-10.415 1.799-7.807 1.592 1.285 1.741 6.352 9.23a90.94 90.94 0 008.474 9.983c5.192 5.666 12.83-3.944 12.83-3.944 17.06-.76 31.799-1.322 39.736-1.622l6.24-.225A227.287 227.287 0 0193.01 44.664c0 1.099 1.049 8.861 3.744 24.224 3.52 19.806 36.766 14.077 37.69 4.393 0 0-64.397-80.246-52.429-71.835z"
            transform="translate(321.488 128.544)"
          ></path>
        </g>
        <path
          fill="url(#35iw9bzmld)"
          fillRule="nonzero"
          d="M373.24 113.591c.399 3.37 2.358 5.517 7.762 5.741 6.826.3 16.748-5.154 25.397-14.252 16.76-17.647 28.704-49.021 3.956-78.998a73.793 73.793 0 00-3.57-4.031c-12.754-13.541-39.698-13.728-54.088-.55-.3.263-.586.537-.873.824-13.416 13.341-16.224 32.136 8.91 46.438 24.1 13.628 11.307 34.732 12.505 44.828z"
        ></path>
        <path
          fill="url(#flvy37a9le)"
          fillRule="nonzero"
          d="M499.911 35.167c-11.057-9.597-27.942-12.83-41.059-6.315a57.38 57.38 0 00-4.168 2.496 32.963 32.963 0 00-10.933 13.728c-5.578 12.605-4.193 22.864-4.143 32.71a38.994 38.994 0 002.284 4.094 40.42 40.42 0 0030.688 18.632c4.83-2.496 10.346-4.842 16.561-7.363 31.487-12.705 29.403-41.82 10.77-57.982z"
        ></path>
        <path
          fill="url(#0qmki2fcff)"
          fillRule="nonzero"
          d="M409.793 24.035a291.622 291.622 0 00-2.221-2.496c-12.767-13.528-39.712-13.728-54.101-.55l-.861.824c-13.416 13.342-16.286 32.149 8.898 46.439a31.871 31.871 0 0110.234 8.736c.312 0 .636.087.96.112 4.83-2.496 10.347-4.842 16.562-7.35 24.448-9.947 28.616-29.79 20.53-45.715z"
        ></path>
        <path
          fill="url(#6l4zopq9bg)"
          fillRule="nonzero"
          d="M463.707 185.975c-20.947-20.738-53.74-23.498-77.859-6.554-24.119 16.945-32.641 48.73-20.234 75.469 14.277-1.96 30.339 4.118 50.594 28.467.636.686 78.125.424 47.499-97.382z"
          opacity="0.4"
        ></path>
        <path
          fill="url(#2sraq4156h)"
          fillRule="nonzero"
          d="M279.228 159.767c-55.586 41.958-33.285 103.41-.337 119.946 41.658 20.891 64.534-36.33 103.446-23.276a80.882 80.882 0 00-52.154-116.063c-17.734 2.77-35.118 7.45-50.955 19.393z"
        ></path>
        <path
          fill="url(#0d0qvrq57i)"
          fillRule="nonzero"
          d="M278.89 279.713c-16.66-8.362-30.588-28.205-33.109-51.168-38.914 33.311-51.747 88.002-31.712 135.146l5.08 2.071a202.142 202.142 0 0157.558 36.292c34.507 30.478 86.171 30.954 121.233 1.116 35.063-29.837 42.858-80.912 18.293-119.85-62.225-74.818-84.914 22.688-137.342-3.607z"
        ></path>
        <path
          fill="url(#fkuqwzcdbj)"
          fillRule="nonzero"
          d="M74.219 51.289C57.558 42.927 43.63 23.084 41.109.12 2.195 33.432-10.638 88.123 9.397 135.267l5.08 2.071a202.142 202.142 0 0157.558 36.292c34.507 30.478 86.171 30.954 121.233 1.116 35.063-29.837 42.858-80.912 18.293-119.85-62.225-74.818-84.914 22.688-137.342-3.607z"
          opacity="0.3"
          transform="translate(204.672 228.424)"
        ></path>
        <path
          fill="url(#pmlwknelqk)"
          fillRule="nonzero"
          d="M111.671 310.775a28.524 28.524 0 01-12.542 14.003l-34.87 19.194a66.984 66.984 0 00-7.026 3.869c-26.997 17.174-37.66 51.323-25.232 80.808 12.428 29.484 44.32 45.697 75.464 38.363 31.145-7.333 52.452-36.07 50.42-68.003a37.438 37.438 0 0114.164-31.874 81.92 81.92 0 00-60.378-56.36z"
        ></path>
        <path
          fill="url(#qsfq0vx1zl)"
          fillRule="nonzero"
          d="M111.783 289.123a29.031 29.031 0 012.06 9.834c12.496 17.219 36.179 21.846 54.237 10.597 18.06-11.249 24.348-34.545 14.403-53.354l-.6-.237a11.017 11.017 0 01-4.867-3.744c-11.446-15.066-32.264-19.357-48.735-10.046-16.471 9.312-23.53 29.361-16.523 46.937l.025.013z"
        ></path>
        <g
          opacity="0.2"
          style={{ mixBlendMode: "multiply" }}
          fillRule="nonzero"
        >
          <path
            fill="url(#cgfxvn8z2p)"
            d="M473.728 23.575c-16.311-14.165-45.327-14.49-56.16 9.984-12.48 28.155 9.86 44.603-25.708 70.949-43.119 31.923-96.321 11.643-138.803 43.68-18.998-16.918-47.157-18.486-67.915-3.783-20.759 14.703-28.624 41.786-18.97 65.321a78.34 78.34 0 015.728 22.664l.137 1.66a10.77 10.77 0 01-14.577 11.007l-1.735-.674a11.101 11.101 0 01-4.867-3.744c-11.446-15.066-32.264-19.357-48.735-10.046-16.472 9.312-23.53 29.361-16.523 46.937 5.43 13.368-.01 28.683-12.654 35.63l-34.87 19.22C8.267 346.558-6.355 380.684 3.941 412.046c10.297 31.362 42.301 50.181 74.713 43.931 32.412-6.25 55.125-35.618 53.022-68.56-1.342-18.518 11.264-35.156 29.453-38.876l1.336-.262a36.71 36.71 0 0120.991 2.022l9.485 3.869a202.098 202.098 0 0157.558 36.292c34.508 30.542 86.23 31.04 121.32 1.167 35.089-29.873 42.85-81.012 18.206-119.952.661.786 84.465.5 43.318-109.574-20.754-55.486-7.65-65.42 29.59-80.509 31.512-12.754 29.428-41.883 10.795-58.02z"
            style={{ mixBlendMode: "color" }}
            transform="translate(26.208 11.48)"
          ></path>
          <path
            fill="url(#jzf78j9plq)"
            d="M334.551 57.183c24.05 13.653 11.307 34.732 12.48 44.829.4 3.37 2.36 5.516 7.763 5.74 6.826.287 16.76-5.154 25.41-14.252 16.747-17.647 28.703-49.021 3.943-78.998a81.732 81.732 0 00-3.57-4.031C367.824-3.07 340.88-3.257 326.49 9.92c-.3.267-.586.541-.86.824-13.404 13.304-16.262 32.111 8.922 46.438z"
            transform="translate(26.208 11.48)"
          ></path>
        </g>
        <path
          fill="url(#sx5jwm3qfr)"
          fillRule="nonzero"
          d="M464.805 417.217l1.473 12.83s-2.92-8.2-5.317-16.15l3.844 3.32z"
          opacity="0.3"
          style={{ mixBlendMode: "multiply" }}
        ></path>
        <path
          fill="url(#1crmxy4oss)"
          fillRule="nonzero"
          opacity="0.3"
          style={{ mixBlendMode: "multiply" }}
          d="M493.035 463.131l-2.209 11.657 4.593-9.947z"
        ></path>
        <path
          fill="#3C48FA"
          fillRule="nonzero"
          d="M383.111 290.133a63.776 63.776 0 01-10.221-2.92 70.031 70.031 0 01-9.635-4.43c-1.572-.824-3.045-1.797-4.542-2.733-.737-.5-1.448-1.024-2.172-1.535a26.136 26.136 0 01-2.097-1.61 57.31 57.31 0 01-7.637-7.326 57.662 57.662 0 007.725 7.2c.68.56 1.388 1.086 2.121 1.573.737.5 1.448 1.011 2.184 1.498 1.51.911 2.996 1.86 4.568 2.658a69.952 69.952 0 009.647 4.268 63.968 63.968 0 0010.159 2.746l-.1.611z"
        ></path>
        <path
          fill="url(#llwcckrlkt)"
          fillRule="nonzero"
          d="M450.054 371.428l6.24 53.752s27.368 9.147 39.187 26.62l-2.683 12.055 9.647 6.914a3.996 3.996 0 011.685 3.42 52.14 52.14 0 01-.65 5.615 9.868 9.868 0 00.562 5.267c1.648 4.081 3.495 12.792-6.951 18.782-14.04 8.075-12.056.537-12.056.537l4.518-8.461a7.91 7.91 0 00.599-6.003l-4.23-14.252s-49.758-24.349-65.121-46.276c0 0-8.736-37.515-1.822-65.495l31.075 7.525z"
        ></path>
        <path
          fill="url(#l3y2n1krlu)"
          fillRule="nonzero"
          d="M450.054 371.428l6.24 53.752s27.368 9.147 39.187 26.62l-2.683 12.055 9.647 6.914a3.996 3.996 0 011.685 3.42 52.14 52.14 0 01-.65 5.615 9.868 9.868 0 00.562 5.267c1.648 4.081 3.495 12.792-6.951 18.782-14.04 8.075-12.056.537-12.056.537l4.518-8.461a7.91 7.91 0 00.599-6.003l-4.23-14.252s-49.758-24.349-65.121-46.276c0 0-8.736-37.515-1.822-65.495l31.075 7.525z"
        ></path>
        <path
          fill="url(#v1mhmn62qv)"
          fillRule="nonzero"
          d="M450.054 371.428l6.24 53.752s27.368 9.147 39.187 26.62l-2.683 12.055 9.647 6.914a3.996 3.996 0 011.685 3.42 52.14 52.14 0 01-.65 5.615 9.868 9.868 0 00.562 5.267c1.648 4.081 3.495 12.792-6.951 18.782-14.04 8.075-12.056.537-12.056.537l4.518-8.461a7.91 7.91 0 00.599-6.003l-4.23-14.252s-49.758-24.349-65.121-46.276c0 0-8.736-37.515-1.822-65.495l31.075 7.525z"
        ></path>
        <g transform="translate(304.666 249.89)">
          <mask id="4fq5fclarz" fill="#fff">
            <use xlinkHref="#y15gl04qcw"></use>
          </mask>
          <use
            fill="url(#lnmycy4pex)"
            fillRule="nonzero"
            xlinkHref="#y15gl04qcw"
          ></use>
          <path
            fill="url(#86az9aixuy)"
            fillRule="nonzero"
            d="M91.212 17.955c-9.223-3.083-20.53 2.645-32.984 1.123C31.283 15.77 17.992 1.18 17.992 1.18s-4.992-2.658-6.876 0C9.23 3.84.208 14.535.208 14.535s35.556 35.568 78.05 26.12c0 0 18.595 41.384 36.766 54.126 0 0 21.079-6.514 31.949-20.604a6.678 6.678 0 018.386-2.06c.643.354 1.225.81 1.723 1.349 0 0 7.712-6.577 4.343-11.557-3.37-4.98-26.046-11.843-32.261-29.553 0 0 40.822-15.275 75.753 8.2 0 0 2.072 3.245 5.916-.824 3.844-4.068 7.975-15.313 3.657-18.632-4.318-3.32-39.475-23.163-90.643-12.555 0 0-10.283 2.845-13.977-1.81l-18.658 11.22z"
            mask="url(#4fq5fclarz)"
          ></path>
          <path
            fill="url(#n3t0kqe41A)"
            fillRule="nonzero"
            d="M91.212 17.955c-9.223-3.083-20.53 2.645-32.984 1.123C31.283 15.77 17.992 1.18 17.992 1.18s-4.992-2.658-6.876 0C9.23 3.84.208 14.535.208 14.535s35.556 35.568 78.05 26.12c0 0 18.595 41.384 36.766 54.126 0 0 21.079-6.514 31.949-20.604a6.678 6.678 0 018.386-2.06c.643.354 1.225.81 1.723 1.349 0 0 7.712-6.577 4.343-11.557-3.37-4.98-26.046-11.843-32.261-29.553 0 0 40.822-15.275 75.753 8.2 0 0 2.072 3.245 5.916-.824 3.844-4.068 7.975-15.313 3.657-18.632-4.318-3.32-39.475-23.163-90.643-12.555 0 0-10.283 2.845-13.977-1.81l-18.658 11.22z"
            mask="url(#4fq5fclarz)"
          ></path>
          <g
            style={{ mixBlendMode: "overlay" }}
            stroke="#FFF"
            strokeWidth="0.624"
            mask="url(#4fq5fclarz)"
          >
            <g transform="translate(-18.874 -11.274)">
              <circle cx="120.182" cy="106.043" r="14.552"></circle>
              <circle cx="171.251" cy="81.008" r="14.552"></circle>
              <circle cx="151.02" cy="59.779" r="6.752"></circle>
              <circle cx="120.182" cy="55.074" r="14.552"></circle>
              <path d="M155.863 99.403a5.156 5.156 0 01-8.799 3.657 5.153 5.153 0 013.657-8.799 5.155 5.155 0 015.142 5.142z"></path>
              <circle cx="125.337" cy="81.008" r="5.142"></circle>
              <path d="M143.607 29.44a5.142 5.142 0 11-10.283 0 5.142 5.142 0 0110.283 0h0z"></path>
              <circle cx="78.961" cy="40.523" r="5.142"></circle>
              <path d="M108.539 26.295a5.156 5.156 0 01-8.799 3.657 5.152 5.152 0 013.657-8.798 5.142 5.142 0 015.142 5.141h0z"></path>
              <circle cx="36.866" cy="12.455" r="5.142"></circle>
              <circle cx="193.34" cy="18.346" r="5.142"></circle>
              <circle cx="55.686" cy="21.94" r="14.552"></circle>
              <circle cx="59.38" cy="58.656" r="14.552"></circle>
              <circle cx="14.589" cy="29.328" r="14.552"></circle>
              <circle cx="162.54" cy="14.864" r="14.552"></circle>
              <circle cx="190.632" cy="43.068" r="14.552"></circle>
              <circle cx="228.746" cy="26.295" r="14.552"></circle>
            </g>
          </g>
        </g>
        <path
          fill="url(#awsrcvmf6B)"
          fillRule="nonzero"
          d="M315.781 251.059s-10.146-8.999-16.149-28.555c0 0-2.858-1.897-2.733 2.708.125 4.606 3.744 14.003 3.744 14.003l-13.99-6.564a1.61 1.61 0 00-1.747 2.645h.087c2.559 2.184 11.494 8.137 11.494 8.137l-17.384 1.323s-1.997 1.585 2.246 2.496c3.753.534 7.543.75 11.332.65l-8.362 5.091s.225 1.323 2.496.973a21.572 21.572 0 004.855-1.572s5.18 8.986 15.85 8.81l8.261-10.145z"
        ></path>
        <path
          fill="url(#x2y08mub6C)"
          fillRule="nonzero"
          d="M309.616 243.708a6.11 6.11 0 00-2.496-1.847 8.723 8.723 0 00-3.007-.45c-.519.01-1.036.055-1.548.138-.262 0-.512.075-.774.125a6.227 6.227 0 01-.86.112l-1.586.125c-.23.017-.46.05-.686.1-.2 0-.375.212-.2 0l-.112.162c-.2.224-.25.412-.225.487a.916.916 0 00.387.424 2.884 2.884 0 001.847.337h.212l.437-.1c.313-.036.63-.015.936.062a2.98 2.98 0 011.448.886c.39.404.665.903.799 1.448.18.666.017 1.378-.437 1.897l.087-.125a7.122 7.122 0 00-1.023 2.796 4.323 4.323 0 00.649 2.82 9.033 9.033 0 002.196 2.272 16.52 16.52 0 002.87 1.684v.088a13.982 13.982 0 01-3.057-1.435 8.583 8.583 0 01-2.496-2.26 4.99 4.99 0 01-.911-3.207 7.311 7.311 0 011.06-3.195 1.683 1.683 0 00-.374-2.159 2.327 2.327 0 00-1.036-.611 2.36 2.36 0 00-1.248.112 3.746 3.746 0 01-2.496-.499 1.56 1.56 0 01-.773-1.036 1.52 1.52 0 01.474-1.248c.193-.22.458-.367.749-.412.267-.056.538-.094.811-.112h1.622a22.978 22.978 0 013.22-.225 8.076 8.076 0 013.158.7 5.886 5.886 0 012.408 2.146h-.025z"
          opacity="0.4"
          style={{ mixBlendMode: "multiply" }}
        ></path>
        <path
          fill="url(#3qjmtdcvtD)"
          fillRule="nonzero"
          d="M532.596 281.248s5.866-2.584 8.736-6.615c2.87-4.03 2.796 1.61 1.248 3.17a54.237 54.237 0 01-4.692 3.894l-5.292-.45z"
        ></path>
        <path
          fill="url(#mtr81st5nE)"
          fillRule="nonzero"
          d="M530.338 280.973a5.192 5.192 0 003.157-2.82c.961-2.247 2.197-.674 1.797.561a4.04 4.04 0 01-.96 1.66l-1.736.874-2.258-.275z"
        ></path>
        <path
          fill="url(#80bhqszbaF)"
          fillRule="nonzero"
          d="M515.499 289.56s2.733 6.002 6.24 7.487c0 0-.275 4.755.811 4.693 1.086-.063 4.792-2.409 4.468-4.505-.325-2.097-1.635-6.615-1.635-6.615l2.284-1.735a9.821 9.821 0 015.416-1.971c2.858-.15 7.126-.562 9.41-1.735a20.623 20.623 0 007.488-6.515 1.448 1.448 0 00-2.221-1.772 26.29 26.29 0 01-5.554 3.844c-1.473.724-13.241 1.847-21.303-3.744.037.012.174 5.379-5.404 12.567z"
        ></path>
        <path d="M407.909 337.607c.73.397 1.402.892 1.997 1.473a6.63 6.63 0 00-1.723-1.348l-.274-.125z"></path>
        <path
          fill="url(#7bqhg2l4aG)"
          fillRule="nonzero"
          d="M451.639 324.054c-10.87 14.09-31.95 20.605-31.95 20.605s-21.29 20.504-26.207 29.078c-4.917 8.574 5.104 19.544 8.736 23.313 9.435 9.834 38.538 30.513 60.116 42.968a2.495 2.495 0 003.744-2.496l-.324-3.132 3.307 3.619 8.96 20.767s1.049 11.456 8.886 6.976c5.192-2.958 4.094-17.222.886-22.801-3.207-5.579-10.495-20.068-11.144-22.464-2.01-7.575-10.371-8.237-12.168-2.496l-34.645-30.214s31.85-23.088 39.2-37.877c7.35-14.789-1.423-24.261-7.376-26.482-.686-.25-1.185-1.011-1.997-1.473a6.701 6.701 0 00-8.024 2.11z"
        ></path>
        <path
          fill="url(#rhu0motb4H)"
          fillRule="nonzero"
          d="M451.639 324.054c-10.87 14.09-31.95 20.605-31.95 20.605s-21.29 20.504-26.207 29.078c-4.917 8.574 5.104 19.544 8.736 23.313 9.435 9.834 38.538 30.513 60.116 42.968a2.495 2.495 0 003.744-2.496l-.324-3.132 3.307 3.619 8.96 20.767s1.049 11.456 8.886 6.976c5.192-2.958 4.094-17.222.886-22.801-3.207-5.579-10.495-20.068-11.144-22.464-2.01-7.575-10.371-8.237-12.168-2.496l-34.645-30.214s31.85-23.088 39.2-37.877c7.35-14.789-1.423-24.261-7.376-26.482-.686-.25-1.185-1.011-1.997-1.473a6.701 6.701 0 00-8.024 2.11z"
        ></path>
        <path
          fill="url(#rnx7lw8inI)"
          fillRule="nonzero"
          d="M14.548 11.806S10.142 1.286.083.5c0 0 13.865-.611 17.984 8.674l-3.52 2.633z"
          opacity="0.3"
          transform="translate(415.376 375.896)"
        ></path>
        <path
          fill="url(#soag35xhlJ)"
          fillRule="nonzero"
          d="M.07 9.31S2.792 1.822 8.57.574a1.91 1.91 0 011.997 2.896L8.182 7.212A7.991 7.991 0 00.07 9.31z"
          opacity="0.3"
          transform="translate(451.568 314.744)"
        ></path>
        <path
          fill="url(#8n048p2s4K)"
          fillRule="nonzero"
          d="M384.97 216.788s-7.487 8.986-4.991 24.661c1.248 7.837 4.405 9.722 7.275 9.635a6.39 6.39 0 016.677 5.204l1.947 11.556s2.122 8.4 10.184 6.952c8.062-1.448 9.385-14.053 8.474-18.171 0 0-4.73-10.583-3.058-16.574 0 0 5.629.849 5.916-4.88.287-5.728-3.507-9.659-5.08-5.84l-.449 1.847a1.521 1.521 0 01-2.296.923 1.508 1.508 0 01-.674-1.597l.986-4.867a12.292 12.292 0 00-5.08-12.792 7.488 7.488 0 00-5.453-1.248 26.956 26.956 0 00-10.334 4.755 4.094 4.094 0 01-4.043.474v-.038z"
        ></path>
        <path
          fill="url(#zt15f5jprL)"
          fillRule="nonzero"
          d="M.574 8.023a.662.662 0 010-1.248c3.544-1.01 9.984-3.157 14.202-6.377a1.872 1.872 0 012.908 2.109 17.283 17.283 0 01-6.003 8.1c-1.922 1.46-4.156.61-5.678-.338A17.337 17.337 0 00.612 8.048l-.038-.025z"
          opacity="0.3"
          transform="translate(389.376 242.112)"
        ></path>
        <path
          fill="url(#egkl9hxp6M)"
          fillRule="nonzero"
          d="M392.546 224.988c-.062.4-.337.686-.612.636-.274-.05-.424-.399-.349-.798.075-.4.35-.687.611-.637.263.05.425.4.35.799z"
        ></path>
        <path
          fill="url(#gqh88w40yN)"
          fillRule="nonzero"
          d="M383.323 224.227c-.075.399-.35.686-.611.636-.262-.05-.425-.412-.35-.811.075-.4.337-.687.612-.637.274.05.424.412.35.812z"
        ></path>
        <path
          fill="url(#hk0zjcrkmO)"
          fillRule="nonzero"
          d="M380.54 230.042l-.075-.237-.087-.2v-.062c0-.062 0 0 0 0l.699-.337c.247-.133.485-.283.711-.45.485-.34.907-.762 1.248-1.247v-.088l-3.107 1.248a.91.91 0 00-.487.737c-.013.296.095.584.3.798l.985 1.36s1.161.537 1.872 0a.973.973 0 00.188-1.322l-2.247-.2z"
        ></path>
        <path
          fill="url(#fqhoc18haP)"
          fillRule="nonzero"
          d="M387.33 236.32l.598-3.133c.076-.429.336-.803.712-1.023a1.522 1.522 0 012.234 1.709 2.712 2.712 0 01-.262.587 5.342 5.342 0 01-3.283 1.86z"
        ></path>
        <path
          fill="url(#e42rd2x2oQ)"
          fillRule="nonzero"
          d="M405.088 208.028c-4.043-3.183-5.129-15.663-17.272-11.807-12.48 3.982-3.644 18.196-3.644 18.196l.799 2.371a4.094 4.094 0 004.043-.474 26.956 26.956 0 0110.334-4.755 7.488 7.488 0 015.453 1.248 12.293 12.293 0 015.08 12.792l-.986 4.868c-.134.62.135 1.26.674 1.597a1.524 1.524 0 002.296-.924l.45-1.847c1.572-3.818 5.366.125 5.079 5.841-.287 5.716-5.916 4.88-5.916 4.88a13.724 13.724 0 00-.237 4.992c.075 0 15.463-7.189 12.705-24.96-1.822-11.607-14.415-8.512-18.858-12.018z"
        ></path>
        <path
          fill="url(#w0prqlfoeR)"
          fillRule="nonzero"
          d="M381.838 236.444a15.95 15.95 0 002.334 0 11.984 11.984 0 002.221-.324 19.177 19.177 0 004.268-1.647 6.564 6.564 0 01-1.797 1.622c-.7.436-1.467.753-2.271.936-1.603.4-3.297.19-4.755-.587z"
        ></path>
        <path
          fill="url(#s1mpuue5hS)"
          fillRule="nonzero"
          d="M391.722 218.885c.163-.51.46-.967.861-1.323a1.787 1.787 0 011.785-.437c.56.285.953.817 1.06 1.436a3.89 3.89 0 010 1.572c-.274-.462-.473-.91-.698-1.31-.225-.4-.474-.762-.724-.836a1.431 1.431 0 00-1.023.174c-.387.262-.811.45-1.26.724z"
        ></path>
        <path
          fill="url(#lrnnfx1maT)"
          fillRule="nonzero"
          d="M383.148 219.572a1.248 1.248 0 01.288-.974c.16-.2.404-.315.661-.312a.96.96 0 01.686.35c.408.56.493 1.294.225 1.934a3.911 3.911 0 01-.55-.736c-.149-.238-.286-.462-.386-.587-.1-.125-.062-.075 0-.075h-.137c-.138 0-.5.237-.787.4z"
        ></path>
        <path
          fill="url(#syyb89gtpU)"
          fillRule="nonzero"
          d="M167.844 115.276a2.896 2.896 0 00-2.659-4.28c-3.644-.125-5.978-3.145-7.226-5.417a1.386 1.386 0 00-2.496 0c-3.744 6.74-9.235 14.826-15.537 18.72-8.624 5.38-22.839-4.68-27.456-5.616l-8.187-3.195c4.742 5.204 15.25 19.656 17.222 27.132 8.337 6.24 27.456 10.583 37.016-5.092 2.995-4.83 8.511-20.03 9.323-22.252z"
        ></path>
        <g stroke="#FFF" strokeWidth="0.624">
          <path
            style={{ mixBlendMode: "overlay" }}
            d="M125.296 111.629l17.096 5.031-5.031 17.096-17.096-5.031zM146.076 133.906l16.462-6.826 6.825 16.463-16.462 6.825zM152.329 102.738l16.462-6.826 6.825 16.463-16.462 6.825z"
          ></path>
        </g>
        <path
          fill="url(#tg0nd2adrV)"
          fillRule="nonzero"
          d="M157.485 105.03c-.599-2.122.811-10.533 7.825-10.895 0 0 8.873-1.248 13.329-1.997 3.32-.549 6.801-1.447 6.053 1.473-.55 2.109-7.214 2.583-8.637 3.744 3.183 1.26 2.409 2.508 2.21 5.004-.163 1.91.474 4.094-1.249 5.541-2.858 2.41-2.733 1.174-6.003 2.36a9.988 9.988 0 01-5.778.736s-5.603 1.734-7.75-5.966z"
        ></path>
        <g
          opacity="0.4"
          style={{ mixBlendMode: "multiply" }}
          fillRule="nonzero"
        >
          <path
            fill="url(#gopwrs5vrW)"
            d="M9.131 6.54a1.66 1.66 0 00.462-1.548 3.015 3.015 0 00-.637-1.248v.112a5.991 5.991 0 00-1.884-1.872A13.249 13.249 0 004.925.661 5.412 5.412 0 002.43.15C1.6.19.78.35-.004.624A8.723 8.723 0 012.404.362c.813.033 1.61.242 2.334.611a12.79 12.79 0 012.01 1.373 5.739 5.739 0 011.684 1.698c.244.29.42.63.512.998.08.368-.038.752-.312 1.01-.626.45-1.47.45-2.097 0a5.587 5.587 0 00-2.134-.948 7.45 7.45 0 00-1.16-.174h-.587l-.175-.225a.735.735 0 01.1.2h-.374a.133.133 0 00-.088 0c.103.102.198.21.287.324h.138A6.562 6.562 0 013.94 8.274c.234 1.285.276 2.597.124 3.894h.063c.129-.65.208-1.31.237-1.972a9.739 9.739 0 00-.075-1.997 7.311 7.311 0 00-1.073-2.957h.075c.366.036.728.098 1.085.187.347.08.686.193 1.011.337l.45.237.474.337a2.334 2.334 0 002.82.2z"
            transform="translate(163.28 93.848)"
          ></path>
          <path
            fill="url(#or70i4chzX)"
            d="M2.442 4.767h.1z"
            transform="translate(163.28 93.848)"
          ></path>
        </g>
        <path
          fill="url(#2yycwiypwY)"
          fillRule="nonzero"
          d="M176.991 106.652a4.305 4.305 0 01-2.084 1.598 3.742 3.742 0 01-2.596-.175.925.925 0 01-.674-.986c.025-.227.111-.442.25-.624.211.026.425.026.637 0l.536-.112c.35-.085.697-.19 1.036-.312a6.687 6.687 0 001.934-1.023 6.454 6.454 0 002.347-3.495 7.37 7.37 0 01-2.571 3.12 7.488 7.488 0 01-3.82 1.248 1.248 1.248 0 01-.973-1.46c0-.699.774-1.036 1.248-1.523l3.095-2.733-.96.662a2.966 2.966 0 010-.4c.026-.145.068-.287.124-.424.015-.168.045-.335.088-.5.049-.241.074-.488.075-.735-.35.3-.606.694-.737 1.135-.081.383.005.783.237 1.099a58.035 58.035 0 00-2.184 1.61c-.274.2-.536.411-.798.636-.09.066-.174.142-.25.225a2.215 2.215 0 00-.225.3c-.11.206-.185.43-.224.66-.08.458 0 .93.224 1.336.231.383.603.661 1.036.774-.162.188-.281.41-.35.649-.058.3-.005.61.15.873.107.19.262.35.45.462a.765.765 0 00-.175.175c-.15.246-.204.54-.15.823.094.366.4.637.774.687a.822.822 0 00.724-.35 1.4 1.4 0 01-.562 0 .473.473 0 01-.324-.374 1.25 1.25 0 010-.686c.881.441 1.896.54 2.845.274a4.52 4.52 0 002.284-1.884 6.245 6.245 0 00.899-2.646h-.063a8.72 8.72 0 01-1.273 2.096z"
          opacity="0.3"
          style={{ mixBlendMode: "multiply" }}
        ></path>
        <path
          fill="url(#97qy3ryvkZ)"
          fillRule="nonzero"
          d="M99.94 102.634l-.187.674a13.384 13.384 0 001.248 10.67 7.081 7.081 0 001.36 1.698c3.532 2.982-7.388 13.728-15.9 2.72a37.727 37.727 0 00-2.27-2.608 9.218 9.218 0 00-4.494-2.696 17.334 17.334 0 01-8.524-5.379s-2.496 3.744-5.566.712c-4.318-4.256-2.745-7.775-.536-6.94a2.58 2.58 0 003.594-1.959c.799-6.14-10.808-10.308-5.566-18.383 2.883-4.467 6.864-1.86 10.071-6.577 3.744-5.516 7.588-3.057 10.746-1.248L96.757 87.92a15.5 15.5 0 013.183 14.714z"
        ></path>
        <path
          fill="url(#q64tqavgyaa)"
          fillRule="nonzero"
          d="M128.37 152.853c-12.48-7.488-3.92-30.388-18.471-35.256-3.931-1.248-8.936-3.619-8.936-3.619a7.081 7.081 0 001.36 1.698c3.532 2.982-7.388 13.728-15.899 2.72a37.465 37.465 0 00-2.271-2.608 9.648 9.648 0 00-3.457-2.359c-4.48.65-9.373 4.668-9.373 4.668L53.34 131.825s12.005-12.967 10.383-16.736c0 0-10.508-4.48-11.52-6.09l-2.795-1.386c-3.47-2.408-1.972 2.933-3.07 4.206-7.575 8.836-13.079 15.887-16.973 26.37-3.27 8.836 3.033 15.65 11.72 17.086 11.78 1.946 19.967-9.573 30.638-1.486 7.488 5.666 23.899 45.328 29.677 34.62 0 .062 30.65-33.347 26.97-35.556z"
        ></path>
        <g stroke="#FFF">
          <path
            strokeWidth="0.624"
            style={{ mixBlendMode: "overlay" }}
            d="M32.98 124.076l14.43 7.057-7.057 14.429-14.429-7.057zM47.084 102.287l15.107-5.457 5.457 15.107-15.107 5.457zM43.148 149.167l15.888-2.352 2.352 15.888-15.888 2.352zM61.434 122.006l14.182-7.54 7.54 14.182-14.182 7.54zM64.206 155.446l12.584-9.982 9.982 12.584-12.584 9.982z"
          ></path>
          <path
            strokeWidth="0.625"
            style={{ mixBlendMode: "overlay" }}
            d="M87.428 173.591l15.58-4.015 4.015 15.58-15.58 4.015z"
          ></path>
          <path
            strokeWidth="0.624"
            style={{ mixBlendMode: "overlay" }}
            d="M95.3 134.312l15.627 3.711-3.711 15.627-15.627-3.711zM103.297 109.348l15.965-1.763 1.763 15.965-15.965 1.763z"
          ></path>
        </g>
        <path
          fill="url(#z16owvhjdab)"
          fillRule="nonzero"
          d="M126.023 193.838c5.928 3.869 28.255 8.024 52.49 11.419-.636 15.675 8.075 28.841 6.066 49.658-.586 6.24-6.24 10.957 1.11 13.728 4.964 1.502 10 2.751 15.09 3.744 9.185 1.96 19.967 6.04 22.376.225 1.435-3.457-.986-5.142-4.156-5.866-7.026-1.585-18.27-9.56-19.78-12.106 0 0 5.178-4.418 5.765-6.864.986-4.118.699-29.428 1.697-38.114.587-5.141 1.723-12.155-2.496-15.986-5.166-4.643-38.213-18.371-38.213-18.371l-39.949 18.533z"
        ></path>
        <path
          fill="url(#psjta23mzac)"
          fillRule="nonzero"
          d="M.183 18.87c5.928 3.869 28.255 8.024 52.49 11.419-.636 15.675 8.075 28.841 6.066 49.658-.586 6.24-6.24 10.957 1.11 13.728 4.964 1.502 10 2.751 15.09 3.744 9.185 1.96 19.967 6.04 22.376.225 1.435-3.457-.986-5.142-4.156-5.866-7.026-1.585-18.27-9.56-19.78-12.106 0 0 5.178-4.418 5.765-6.864.986-4.118.699-29.428 1.697-38.114.587-5.141 1.723-12.155-2.496-15.986C73.18 14.065 40.132.337 40.132.337L.183 18.87z"
          opacity="0.5"
          transform="translate(125.84 174.968)"
        ></path>
        <path
          fill="#A031DD"
          fillRule="nonzero"
          d="M53.34 131.887a4.26 4.26 0 013.27 2.496 5.245 5.245 0 01-.15 4.33 11.226 11.226 0 01-2.571 3.345c-.512.45-1.074.849-1.623 1.248-.549.4-1.173.7-1.784 1.011.449-.524.923-1.01 1.385-1.485l1.323-1.473a15.196 15.196 0 002.171-3.132 4.619 4.619 0 00-1.984-6.34h-.037z"
        ></path>
        <path
          fill="#A031DD"
          fillRule="nonzero"
          d="M53.34 131.887a9.263 9.263 0 013.469.612 7.001 7.001 0 014.543 5.241 9.847 9.847 0 01.1 3.52 15.446 15.446 0 00-.575-3.408 8.024 8.024 0 00-1.572-2.932 10.397 10.397 0 00-5.965-3.033z"
        ></path>
        <path
          fill="url(#54chqxnqdad)"
          fillRule="nonzero"
          d="M113.019 158.52s31.911-15.276 59.055-17.098a29.441 29.441 0 0121.216 9.871c9.136 10.259 33.796 40.922 33.796 40.922l9.685-15.6s4.505-7.325 9.372-1.71c4.867 5.617-6.415 36.941-13.091 39.762-6.677 2.82-9.984-4.493-9.984-4.493-.238-.874-5.666-6.24-8.736-10.758a63.09 63.09 0 00-19.47-18.383 72.477 72.477 0 01-9.497-6.627 12.58 12.58 0 00-13.528-1.86l-44.404 21.105s-22.464 7.775-27.144-3.82c-4.68-11.593 4.219-26.008 12.73-31.312z"
        ></path>
        <path
          fill="url(#0jion7hq5ae)"
          fillRule="nonzero"
          d="M113.019 158.52s31.911-15.276 59.055-17.098a29.441 29.441 0 0121.216 9.871c9.136 10.259 33.796 40.922 33.796 40.922l9.685-15.6s4.505-7.325 9.372-1.71c4.867 5.617-6.415 36.941-13.091 39.762-6.677 2.82-9.984-4.493-9.984-4.493-.238-.874-5.666-6.24-8.736-10.758a63.09 63.09 0 00-19.47-18.383 72.477 72.477 0 01-9.497-6.627 12.58 12.58 0 00-13.528-1.86l-44.404 21.105s-22.464 7.775-27.144-3.82c-4.68-11.593 4.219-26.008 12.73-31.312z"
        ></path>
        <path
          fill="url(#r4s05xelsaf)"
          fillRule="nonzero"
          d="M21.253 2.421c-4.305-6.777-10.932 9.784-12.866 16.973-1.773 6.577-10.21 14.564-6.902 20.355l.474.2a6.746 6.746 0 005.205-.225c6.002-2.509 15.75-28.068 14.09-37.303z"
          opacity="0.3"
          transform="translate(225.888 174.968)"
        ></path>
        <path
          fill="url(#on5jnuw8kag)"
          fillRule="nonzero"
          d="M247.141 177.39c-4.305-6.778-10.932 9.783-12.866 16.972-1.773 6.577-10.21 14.564-6.902 20.355l.474.2a6.746 6.746 0 005.205-.225c6.002-2.509 15.75-28.068 14.09-37.303z"
        ></path>
        <path
          fill="url(#3nm72vptyah)"
          fillRule="nonzero"
          d="M39.699 7.812c-3.744-4.854-13.204-.723-19.88-1.747C13.14 5.042 7.487.075 2.57.087c-4.917.013-.337 3.744-.337 3.744a153.44 153.44 0 0015.088 3.744c9.186 1.972 19.98 6.053 22.377.237z"
          opacity="0.3"
          transform="translate(183.456 264.824)"
        ></path>
        <path
          fill="url(#i61rvwfoaai)"
          fillRule="nonzero"
          d="M223.155 272.636c-3.744-4.854-13.204-.723-19.88-1.747-6.678-1.023-12.331-5.99-17.248-5.978-4.917.013-.337 3.744-.337 3.744a153.44 153.44 0 0015.088 3.744c9.186 1.972 19.98 6.053 22.377.237z"
        ></path>
        <path
          fill="url(#iim6u07hoaj)"
          fillRule="nonzero"
          d="M13.836 1.647a.712.712 0 00-1.248-.449 12.383 12.383 0 01-2.97 3.282A18.369 18.369 0 01.807 7.089a.63.63 0 10-.188 1.248 34.752 34.752 0 008.325 2.496c2.708.15 5.978-.624 5.154-3.37a18.205 18.205 0 01-.262-5.816z"
          opacity="0.2"
          transform="translate(84.656 106.328)"
        ></path>
        <path
          fill="url(#spe0p290sak)"
          fillRule="nonzero"
          d="M70.574 87.009a3.348 3.348 0 01-.237-1.76c.07-.668.408-1.28.936-1.697a2.625 2.625 0 011.897-.412c.293.063.58.146.861.25.267.135.525.285.774.449h-1.672a2.714 2.714 0 00-1.248.424c-.367.29-.64.68-.786 1.124-.22.525-.395 1.068-.525 1.622z"
        ></path>
        <path
          fill="url(#tmo43rcb6al)"
          fillRule="nonzero"
          d="M83.167 78.448a3.197 3.197 0 01-.787-1.386 1.748 1.748 0 01.437-1.772 2.047 2.047 0 011.772-.312c.514.14.993.382 1.41.712h-1.497c-.462 0-.886.074-1.06.274a1.345 1.345 0 00-.313.986c-.025.45 0 .961.038 1.498z"
        ></path>
        <path
          fill="#A031DD"
          fillRule="nonzero"
          d="M93.525 93.623a21.073 21.073 0 01-2.858 2.496 1.25 1.25 0 00.262 2.109 3.743 3.743 0 003.482-.112c1.248-.948 1.011-2.758.624-4.018a.912.912 0 00-1.51-.475z"
        ></path>
        <path
          fill="url(#9k3bfx6f4am)"
          fillRule="nonzero"
          d="M78.599 90.179a3.5 3.5 0 01-.899.686 2.65 2.65 0 01-1.048.325 1.93 1.93 0 01-1.036-.187 2.793 2.793 0 01-.773-.575 1.868 1.868 0 001.672.15c.244-.104.461-.262.636-.462.17-.189.31-.403.412-.636l1.036.699z"
        ></path>
        <path
          fill="url(#yvykr6yzdan)"
          fillRule="nonzero"
          d="M88.858 80.844c.148.027.3.027.449 0 .149-.01.294-.052.424-.125.289-.259.441-.637.412-1.023.274.436.307.981.087 1.447a1.586 1.586 0 01-.574.612 2.27 2.27 0 01-.798.324v-1.235z"
        ></path>
        <path
          fill="url(#llem6ljmiao)"
          fillRule="nonzero"
          d="M2.446 2.296L.012 7.763.836.3z"
          opacity="0.3"
          transform="translate(224.64 189.944)"
        ></path>
        <path
          fill="url(#g4l42ovpfap)"
          fillRule="nonzero"
          d="M34.495.023L10.783 20.79S3.494 19.18.05 16.41L34.495.023z"
          opacity="0.3"
          transform="translate(127.296 177.216)"
        ></path>
        <path
          fill="url(#6j1ex5blbaq)"
          fillRule="nonzero"
          d="M.05 6.785S9.734 4.851 12.83.121c0 0-4.993 12.405-12.643 12.055L.05 6.785z"
          opacity="0.3"
          transform="translate(178.464 198.472)"
        ></path>
        <path
          fill="url(#jgqq409iear)"
          fillRule="nonzero"
          d="M93.338 88.244a1.833 1.833 0 000-1.672 2.418 2.418 0 00-1.323-1.036 20.786 20.786 0 01-1.435-.848 39.345 39.345 0 01-5.267-4.131l-.062.075a15.957 15.957 0 004.83 4.842c.5.306 1.017.585 1.547.836.662.287.836.312 1.073.6.24.327.305.75.175 1.135-3.232-.3-2.808 1.685-1.934 2.084 1.248.55 1.647-.374 1.647-.374l.187-.425c.176-.29.318-.6.425-.923l.137-.163z"
          opacity="0.4"
          style={{ mixBlendMode: "multiply" }}
        ></path>
        <path
          fill="url(#4z9dxphwgas)"
          fillRule="nonzero"
          d="M79.073 91.252c-.4.3-1.248-.112-1.76-.898-.511-.787-.698-1.66-.299-1.947.4-.287 1.186.112 1.76.898.574.787.736 1.66.3 1.947z"
        ></path>
        <path
          fill="url(#3l3bu3gk9at)"
          fillRule="nonzero"
          d="M89.569 82.89c-.4.288-1.248-.112-1.76-.898-.511-.786-.699-1.66-.3-1.947.4-.287 1.186.1 1.76.899.575.798.712 1.66.3 1.947z"
        ></path>
        <path
          fill="#A031DD"
          fillRule="nonzero"
          d="M128.37 152.853a22.248 22.248 0 00-4.993-1.435 17.223 17.223 0 00-4.992-.125 16.39 16.39 0 00-4.83 1.248c-.786.32-1.553.687-2.296 1.099-.761.399-1.447.923-2.221 1.335a23.99 23.99 0 011.884-1.835c.69-.56 1.43-1.057 2.21-1.485a13.605 13.605 0 015.116-1.635 13.732 13.732 0 0110.121 2.833z"
        ></path>
        <path
          fill="url(#6gs09yuk1au)"
          fillRule="nonzero"
          d="M65.607 108.425c-4.318-4.256-2.745-7.775-.536-6.94a2.58 2.58 0 003.594-1.959c.799-6.14-10.808-10.308-5.566-18.383 2.883-4.467 6.864-1.86 10.071-6.577 3.744-5.516 7.588-3.057 10.746-1.248 12.043-23.312-25.235-16.224-28.168-27.33-1.435-5.455 6.365-8.887 4.68-14.977-3.282-11.918-14.052-6.889-21.84-12.268C27.681 11.255 30.863.473 22.202.023 7.937-.65 12.829 15.536 9.535 22.912 6.04 30.724 1.123 38.087.66 42.455c-2.808 26.071 23.226 24.012 28.567 29.229 5.94 5.803-8.836 26.133 11.744 28.704 8.736 1.098 7.001 9.547 14.027 13.802 2.746 1.673 14.178 2.397 17.472-4.992v-.15c-.48-.43-.93-.893-1.347-1.385 0 0-2.496 3.757-5.517.762z"
        ></path>
        <path
          fill="url(#6wybi8ic7av)"
          fillRule="nonzero"
          d="M65.607 108.425c-4.318-4.256-2.745-7.775-.536-6.94a2.58 2.58 0 003.594-1.959c.799-6.14-10.808-10.308-5.566-18.383 2.883-4.467 6.864-1.86 10.071-6.577 3.744-5.516 7.588-3.057 10.746-1.248 12.043-23.312-25.235-16.224-28.168-27.33-1.435-5.455 6.365-8.887 4.68-14.977-3.282-11.918-14.052-6.889-21.84-12.268C27.681 11.255 30.863.473 22.202.023 7.937-.65 12.829 15.536 9.535 22.912 6.04 30.724 1.123 38.087.66 42.455c-2.808 26.071 23.226 24.012 28.567 29.229 5.94 5.803-8.836 26.133 11.744 28.704 8.736 1.098 7.001 9.547 14.027 13.802 2.746 1.673 14.178 2.397 17.472-4.992v-.15c-.48-.43-.93-.893-1.347-1.385 0 0-2.496 3.757-5.517.762z"
        ></path>
        <path
          fill="url(#n5bi13t06aw)"
          fillRule="nonzero"
          d="M441.73 191.217c-5.629-3.956-15.638-24.373-37.103-46.862 0 0-20.393.698-46.002 1.847 0 0-7.625 9.61-12.83 3.956a93.895 93.895 0 01-8.473-9.984c-5.067-7.588-15.288-17.01-10.908-21.216 2.621-2.496 7.364-2.134 9.148.474 3.956 5.778 15.2 13.054 18.034 13.516 0 0-1.735-7.925.274-9.335 0 0 37.266-2.247 46.176-4.019 4.93-.986 19.968-.536 25.185 9.285 3.182 5.928 16.499 62.338 16.499 62.338z"
        ></path>
        <path
          fill="url(#0iodtgmpoax)"
          fillRule="nonzero"
          d="M441.73 191.217c-5.629-3.956-15.638-24.373-37.103-46.862 0 0-20.393.698-46.002 1.847 0 0-7.625 9.61-12.83 3.956a93.895 93.895 0 01-8.473-9.984c-5.067-7.588-15.288-17.01-10.908-21.216 2.621-2.496 7.364-2.134 9.148.474 3.956 5.778 15.2 13.054 18.034 13.516 0 0-1.735-7.925.274-9.335 0 0 37.266-2.247 46.176-4.019 4.93-.986 19.968-.536 25.185 9.285 3.182 5.928 16.499 62.338 16.499 62.338z"
        ></path>
        <path
          fill="url(#562rp3amnay)"
          fillRule="nonzero"
          d="M441.73 191.217c-5.629-3.956-15.638-24.373-37.103-46.862 0 0-20.393.698-46.002 1.847 0 0-7.625 9.61-12.83 3.956a93.895 93.895 0 01-8.473-9.984c-5.067-7.588-15.288-17.01-10.908-21.216 2.621-2.496 7.364-2.134 9.148.474 3.956 5.778 15.2 13.054 18.034 13.516 0 0-1.735-7.925.274-9.335 0 0 37.266-2.247 46.176-4.019 4.93-.986 19.968-.536 25.185 9.285 3.182 5.928 16.499 62.338 16.499 62.338z"
        ></path>
        <path
          fill="url(#spor5k4xnaz)"
          fillRule="nonzero"
          d="M353.633 132.898s2.247 6.59 3.644 9.984a32.736 32.736 0 01-7.15-11.47l3.506 1.486z"
          opacity="0.3"
          style={{ mixBlendMode: "multiply" }}
        ></path>
        <path
          fill="url(#uvyyu8t1taA)"
          fillRule="nonzero"
          opacity="0.3"
          style={{ mixBlendMode: "multiply" }}
          d="M420.389 162.788l-12.093-42.744 9.497 5.116z"
        ></path>
        <path
          fill="url(#r5ubi9nf8aB)"
          fillRule="nonzero"
          opacity="0.3"
          style={{ mixBlendMode: "multiply" }}
          d="M404.627 144.355l-12.555-7.775 6.215 8.012z"
        ></path>
        <path
          fill="url(#gl2t1wjqzaC)"
          fillRule="nonzero"
          d="M461.872 191.404s-12.692-53.215-22.826-77.576a56.895 56.895 0 00-15.986-17.297c-12.93-9.223-50.894-29.116-50.894-29.116l9.373-15.15s4.417-7.077-2.559-8.874c-6.976-1.797-29.315 21.528-28.891 28.517.424 6.989 8.25 6.74 8.25 6.74.86-.175 7.862 2.233 13.128 2.995 1.136.162 0 9.984 1.822 11.232 12.13 8.386 31.637 24.31 44.504 32.26l1.597 28.205a339.394 339.394 0 004.78 33.696c3.894 19.706 36.791 14.065 37.702 4.368z"
        ></path>
        <path
          fill="url(#z7nb7udw1aD)"
          fillRule="nonzero"
          d="M461.872 191.404s-12.692-53.215-22.826-77.576a56.895 56.895 0 00-15.986-17.297c-12.93-9.223-50.894-29.116-50.894-29.116l9.373-15.15s4.417-7.077-2.559-8.874c-6.976-1.797-29.315 21.528-28.891 28.517.424 6.989 8.25 6.74 8.25 6.74.86-.175 7.862 2.233 13.128 2.995 1.136.162 0 9.984 1.822 11.232 12.13 8.386 31.637 24.31 44.504 32.26l1.597 28.205a339.394 339.394 0 004.78 33.696c3.894 19.706 36.791 14.065 37.702 4.368z"
        ></path>
        <path
          fill="url(#25133il8faE)"
          fillRule="nonzero"
          d="M461.872 191.404s-12.692-53.215-22.826-77.576a56.895 56.895 0 00-15.986-17.297c-12.93-9.223-50.894-29.116-50.894-29.116l9.373-15.15s4.417-7.077-2.559-8.874c-6.976-1.797-29.315 21.528-28.891 28.517.424 6.989 8.25 6.74 8.25 6.74.86-.175 7.862 2.233 13.128 2.995 1.136.162 0 9.984 1.822 11.232 12.13 8.386 31.637 24.31 44.504 32.26l1.597 28.205a339.394 339.394 0 004.78 33.696c3.894 19.706 36.791 14.065 37.702 4.368z"
        ></path>
        <path
          fill="url(#0gbg1m6o8aF)"
          fillRule="nonzero"
          opacity="0.3"
          style={{ mixBlendMode: "multiply" }}
          d="M417.793 125.16l.012-8.399-2.62 6.727z"
        ></path>
        <path
          fill="url(#m2nn32twfaG)"
          fillRule="nonzero"
          d="M26.97.874c7.75.81-3.745 13.728-9.186 18.507-4.992 4.38-8.25 15.164-14.689 14.79l-.387-.325a6.585 6.585 0 01-2.058-4.63C.262 22.926 18.246 3.519 26.969.874z"
          opacity="0.3"
          transform="translate(349.44 42.68)"
        ></path>
        <path
          fill="url(#7s8m5yhkwaH)"
          fillRule="nonzero"
          d="M376.41 43.554c7.75.81-3.745 13.728-9.186 18.507-4.992 4.38-8.25 15.164-14.689 14.79l-.387-.325a6.59 6.59 0 01-2.059-4.63c-.387-6.29 17.597-25.697 26.32-28.342z"
        ></path>
        <path
          fill="url(#ycl9fn4soaI)"
          fillRule="nonzero"
          d="M1.51-.002L.786 8.947 2.558.635z"
          opacity="0.3"
          transform="translate(370.656 67.392)"
        ></path>
        <path
          fill="url(#2vysxtpzcaJ)"
          fillRule="nonzero"
          d="M530.412 125.422s-1.672-.973 7.488 8.562c0 0-50.057 48.971-62.4 56.235-5.952 3.481-13.628 1.185-13.628 1.185l-17.035-53.576s10.296-11.232 19.968-12.119c19.307-8.361 41.72-16.798 53.19-19.156l12.417 18.87z"
        ></path>
        <path
          stroke="#FFF"
          strokeWidth="0.624"
          opacity="0.5"
          style={{ mixBlendMode: "overlay" }}
          d="M501.821 116.412l7.675 14.314 7.75-14.164z"
        ></path>
        <path
          fill="#3C48FA"
          fillRule="nonzero"
          d="M455.245 131.064c1.872 1.148 3.744 2.233 5.741 3.194 1.997.961 3.919 1.935 5.928 2.77a82.033 82.033 0 0012.355 4.12 59.035 59.035 0 0012.892 1.746h3.258c1.085 0 2.159-.224 3.244-.324l1.623-.15c.536-.087 1.073-.224 1.61-.324 1.06-.237 2.134-.45 3.22-.662a41.49 41.49 0 01-12.955 2.496 50.847 50.847 0 01-13.166-1.435 65.67 65.67 0 01-12.48-4.468 60.533 60.533 0 01-11.27-6.964z"
        ></path>
        <path
          stroke="#FFF"
          strokeWidth="0.624"
          opacity="0.5"
          style={{ mixBlendMode: "overlay" }}
          d="M475.763 142.77l13.865 8.461-.487-16.149zm-16.599-18.433l.886 16.211 13.029-9.547zm81.382 11.98l-7.438-16.823-9.984 15.338zm-43.617 3.57l11.144 14.851 6.315-17.36zm-1.56-9.622l-.961-20.23-16.324 11.793zm-15.887 41.396l-.961-20.23-16.324 11.793z"
        ></path>
        <path
          fill="url(#5dkb3db8haK)"
          fillRule="nonzero"
          d="M530.412 125.422s-1.672-.973 7.488 8.562c0 0-50.057 48.971-62.4 56.235-5.952 3.481-13.628 1.185-13.628 1.185l-17.035-53.576s10.296-11.232 19.968-12.119c19.307-8.361 41.72-16.798 53.19-19.156l12.417 18.87z"
        ></path>
        <path
          fill="url(#5vndsn3r6aL)"
          fillRule="nonzero"
          d="M464.78 126.533c19.307-8.361 41.72-16.798 53.19-19.157 0 0-1.672-11.519-12.268-8.336-10.595 3.182-42.432 16.311-42.432 16.311a31.62 31.62 0 00-16.336 4.193s1.66 8.225.574 12.405c0 0 2.845 4.518 6.352 6.49l-.574-3.831s1.847-7.189 11.494-8.075z"
        ></path>
        <path
          stroke="#FFF"
          strokeWidth="0.624"
          opacity="0.5"
          style={{ mixBlendMode: "overlay" }}
          d="M521.801 106.128l-10.895-10.283-2.646 14.664zm-22.863-6.664l-14.489 3.831 11.057 9.984zM449.205 115.9l5.716 13.84 8.436-12.28z"
        ></path>
        <path
          fill="#3C48FA"
          fillRule="nonzero"
          d="M463.295 115.351a6.649 6.649 0 013.245 0 6.139 6.139 0 012.983 1.597 5.194 5.194 0 011.422 3.033 6.682 6.682 0 010 1.66 10.61 10.61 0 01-.387 1.572c-.112-.536-.15-1.048-.224-1.56a10.519 10.519 0 00-.362-1.46 5.698 5.698 0 00-1.41-2.408 10.525 10.525 0 00-5.267-2.434z"
        ></path>
        <path
          stroke="#FFF"
          strokeWidth="0.624"
          opacity="0.5"
          style={{ mixBlendMode: "overlay" }}
          d="M469.56 118.983l14.24 4.667-3.857-14.402z"
        ></path>
        <path
          fill="url(#6s1k6aompaM)"
          fillRule="nonzero"
          d="M464.78 126.533c19.307-8.361 41.72-16.798 53.19-19.157 0 0-1.672-11.519-12.268-8.336-10.595 3.182-42.432 16.311-42.432 16.311a31.62 31.62 0 00-16.336 4.193s1.66 8.225.574 12.405c0 0 2.845 4.518 6.352 6.49l-.574-3.831s1.847-7.189 11.494-8.075z"
        ></path>
        <path
          fill="url(#tm9mr36y8aN)"
          fillRule="nonzero"
          d="M548.321 106.228a2.583 2.583 0 01-1.447-2.496 20.055 20.055 0 011.734-6.864 4.767 4.767 0 00-1.847-6.078c-3.37-2.021-8.037-4.854-10.807-6.701-2.496-1.66-5.878-.175-8.137 1.248v.337s-16.075 15.525-9.173 28.267l-1.785 3.182s-3.432 2.908 2.621 8.112c0 0 6.415 5.28 10.97.2 2.084-2.321 12.23-9.984 12.23-9.984s.487 2.134 4.73.636c5.417-1.897 11.494-9.222 5.491-10.982a6.99 6.99 0 00-4.58 1.123z"
        ></path>
        <path
          fill="url(#o0x9qo4lbaO)"
          fillRule="nonzero"
          d="M560.864 86.797c-1.473-2.746-14.59-23.113-24.96-17.684-8.137 4.268-8.225 14.302-8.175 16.224 2.26-1.423 5.641-2.908 8.137-1.248 2.77 1.847 7.488 4.68 10.808 6.701a4.768 4.768 0 011.847 6.078 20.079 20.079 0 00-1.735 6.864 2.583 2.583 0 001.448 2.496 6.986 6.986 0 014.618-1.185c.274-.125 8.424-3.882 6.24-10.895.05 0 4.542-2.172 1.772-7.351z"
        ></path>
        <path
          fill="url(#wapti065naP)"
          fillRule="nonzero"
          d="M560.864 86.797c-1.473-2.746-14.59-23.113-24.96-17.684-8.137 4.268-8.225 14.302-8.175 16.224 2.26-1.423 5.641-2.908 8.137-1.248 2.77 1.847 7.488 4.68 10.808 6.701a4.768 4.768 0 011.847 6.078 20.079 20.079 0 00-1.735 6.864 2.583 2.583 0 001.448 2.496 6.986 6.986 0 014.618-1.185c.274-.125 8.424-3.882 6.24-10.895.05 0 4.542-2.172 1.772-7.351z"
        ></path>
        <path
          fill="url(#vxdvf9h53aQ)"
          fillRule="nonzero"
          d="M527.966 101.249c-.674.973-1.322 1.61-1.772 2.271-.1.125 0 0 0 0v-.062s-.112 0 0 .112c.504.247.964.576 1.36.973v.088l-1.51-.35a.809.809 0 01-.636-.499.75.75 0 01.137-.799 5.787 5.787 0 012.496-1.822l-.075.088z"
        ></path>
        <path
          fill="url(#618mdo5l0aR)"
          fillRule="nonzero"
          d="M530.238 87.383a2.848 2.848 0 011.847-.611 1.64 1.64 0 011.06.45c.272.283.458.638.537 1.022a3.956 3.956 0 01-.224 1.972 5.844 5.844 0 01-.886 1.673c.167-1.145.23-2.302.187-3.457a1.074 1.074 0 00-.799-.949 5.115 5.115 0 00-1.722-.1z"
        ></path>
        <path
          fill="url(#sbiv9n0euaS)"
          fillRule="nonzero"
          d="M522.475 107.501a7.586 7.586 0 003.457 2.696c.695.261 1.414.453 2.147.574.736.137 1.485.175 2.259.25-.375.087-.762.137-1.149.212-.386.075-.773 0-1.16 0a7.503 7.503 0 01-2.321-.487 6.012 6.012 0 01-1.997-1.248 4.495 4.495 0 01-1.236-1.997z"
        ></path>
        <path
          fill="url(#lgdvii026aT)"
          fillRule="nonzero"
          d="M451.427 122.003a7.7 7.7 0 008.449-8.199.732.732 0 010-.175c-.487-4.768 3.357-7.875 9.784-15.75 0 0 0-2.883-3.17-.636-3.17 2.246-8.025 9.172-8.025 9.172l-1.934-12.867a1.36 1.36 0 00-2.671 0v.075c-.324 2.82-.312 11.856-.312 11.856l-9.06-11.544s-2.047-.649-.712 2.746a57.64 57.64 0 004.843 8.237l-7.488-3.47s-.824.774.449 2.16a18.886 18.886 0 003.37 2.67 16.735 16.735 0 00-1.249 9.048 7.889 7.889 0 007.077 6.59l.649.087z"
        ></path>
        <path
          fill="url(#l6qv3091haU)"
          fillRule="nonzero"
          d="M459.514 114.84c.294-.85.363-1.762.2-2.646a6.925 6.925 0 00-1.062-2.384 21.447 21.447 0 00-1.722-2.084l-.823-1.061a3.959 3.959 0 00-.425-.462c-.125-.137-.337-.2-.262-.187h-.112c-.587-.062-.811.137-.811.749.03.599.268 1.168.674 1.61l.15.137.249.237c.152.182.27.389.35.612.14.401.162.834.062 1.248a2.498 2.498 0 01-.574 1.148 1.534 1.534 0 01-1.348.511h.087a6.05 6.05 0 00-2.496.624 3.915 3.915 0 00-1.76 1.947 7.651 7.651 0 00-.511 2.671c-.02.938.06 1.875.237 2.796a10.568 10.568 0 01-.587-2.783 6.972 6.972 0 01.325-2.896 4.48 4.48 0 011.872-2.334 6.429 6.429 0 012.883-.836h.087c.35.075.799-.424.899-.986.076-.256.076-.53 0-.786a1.25 1.25 0 00-.188-.3l-.374-.349a3.57 3.57 0 01-.911-2.246 1.498 1.498 0 011.872-1.623h-.112c.351.011.682.17.91.437.174.178.336.365.487.562.288.374.537.761.787 1.123.58.709 1.114 1.455 1.597 2.234a6.24 6.24 0 01.911 2.633 4.77 4.77 0 01-.561 2.683z"
          opacity="0.4"
          style={{ mixBlendMode: "multiply" }}
        ></path>
        <path
          fill="url(#u02qy6rjqaV)"
          fillRule="nonzero"
          d="M529.601 96.843c-.212.325-.549.474-.761.337-.212-.137-.225-.512 0-.836l.761.5z"
        ></path>
        <path
          fill="url(#3ftk2b8omaW)"
          fillRule="nonzero"
          d="M529.776 96.943a3.209 3.209 0 01-1.048-.337 4.521 4.521 0 01-.886-.586l-.188-.163.075-.15c.092-.167.225-.31.387-.411a.963.963 0 01.5-.15 2.718 2.718 0 00-.25.387 1.24 1.24 0 00-.125.35l-.112-.313c.327.147.633.335.91.562.29.227.538.502.737.811z"
        ></path>
        <path
          fill="url(#k1dz4jllsaX)"
          fillRule="nonzero"
          d="M536.64 100.962c-.212.324-.55.474-.761.337-.212-.138-.225-.512 0-.837l.761.5z"
        ></path>
        <path
          fill="url(#q0vbhi364aY)"
          fillRule="nonzero"
          d="M536.79 101.111a3.214 3.214 0 01-1.049-.337 4.215 4.215 0 01-.886-.586l-.187-.162.075-.15c.088-.17.222-.313.387-.412a.942.942 0 01.5-.15 2.776 2.776 0 00-.25.387.897.897 0 00-.125.35l-.113-.312c.325.15.63.34.911.561.286.23.535.504.737.811z"
        ></path>
        <path
          fill="url(#omvj39h1xaZ)"
          fillRule="nonzero"
          d="M537.95 133.984c3.744 6.315-6.801 17.097-18.245 26.058-9.922 7.762-33.859 23.238-44.042 18.994-11.844-4.917-30.826-41.184-30.826-41.184s8.3-3.606 8.736-9.484a27.018 27.018 0 005.055 6.876c21.003 20.954 20.99 21.141 20.542 26.208.399-5.653.224-11.232 37.577-24.273-.038-.05 16.473-11.282 21.203-3.195z"
        ></path>
        <path
          stroke="#FFF"
          strokeWidth="0.624"
          opacity="0.5"
          style={{ mixBlendMode: "overlay" }}
          d="M534.855 152.092l10.683-17.085-20.03.387z"
        ></path>
        <path
          fill="#3C48FA"
          fillRule="nonzero"
          d="M479.132 159.455c1.385.14 2.742.475 4.031.999a14.14 14.14 0 013.657 2.109 7.293 7.293 0 012.496 3.532 5.253 5.253 0 01-.612 4.168 6.56 6.56 0 00-.312-3.831 7.72 7.72 0 00-2.383-2.908 37.397 37.397 0 00-6.877-4.069zm3.332-2.321a34.35 34.35 0 004.181 1.023c1.402.287 2.819.5 4.243.637 2.841.318 5.708.318 8.55 0a27.472 27.472 0 008.174-2.284l1.896-.986c.612-.362 1.174-.811 1.76-1.248l.886-.599.799-.724 1.585-1.46a21.85 21.85 0 01-6.714 5.404 25.957 25.957 0 01-8.324 2.496c-2.883.3-5.791.25-8.662-.15a36.382 36.382 0 01-8.374-2.109z"
        ></path>
        <path
          stroke="#FFF"
          strokeWidth="0.624"
          opacity="0.5"
          style={{ mixBlendMode: "overlay" }}
          d="M503.418 161.19l-7.101-18.857-11.843 16.149zm-9.26 28.754l-.724-20.13-16.374 11.531zm-28.666-18.371l-.724-20.13-16.374 11.532zm58.755-15.912l.213-11.581-9.747 6.115zm-72.097-4.018l.213-11.569-9.76 6.115zm29.303 1.959l-10.595-4.667 1.872 11.357zm41.222 14.215l-11.694-9.809-1.822 15.076z"
        ></path>
        <path
          fill="url(#7eeifp8pxba)"
          fillRule="nonzero"
          d="M537.95 133.984c3.744 6.315-6.801 17.097-18.245 26.058-9.922 7.762-33.859 23.238-44.042 18.994-11.844-4.917-30.826-41.184-30.826-41.184s8.3-3.606 8.736-9.484a27.018 27.018 0 005.055 6.876c21.003 20.954 20.99 21.141 20.542 26.208.399-5.653.224-11.232 37.577-24.273-.038-.05 16.473-11.282 21.203-3.195z"
        ></path>
        <path
          fill="url(#r34u1wc62bb)"
          fillRule="nonzero"
          d="M453.536 128.343l-7.925-11.594a5.672 5.672 0 00-2.995-2.21l-11.37-2.12s-.836 2.495 2.933 3.618c2.496.737 5.479 1.398 5.479 1.398s-3.008-.412-7.713 3.744c-3.744 3.22-1.148 4.468 1.123 2.808 1.785-1.248 1.897-2.034 5.679-1.76a8.738 8.738 0 00-4.131 6.24c-.262 2.31 2.82-1.023 2.82-1.023s.3-.774 2.06-.836c0 0-.724 7.064 3.956 8.96l1.385 2.347s8.736-3.108 8.699-9.572z"
        ></path>
        <path
          fill="url(#1fryok3snbc)"
          fillRule="nonzero"
          d="M444.55 115.6s-6.34-6.589-6.964-7.275c-.624-.687-1.81 1.46-.449 3.12.911 1.098 1.91 2.383 1.91 2.383l5.503 1.773z"
        ></path>
        <path
          fill="url(#uq3e80iiobd)"
          fillRule="nonzero"
          d="M3.628.362a29.389 29.389 0 0011.044.849.973.973 0 01.549 1.847C9.581 5.878 1.231 9.435.358 6.315a7.733 7.733 0 010-4.095A2.631 2.631 0 013.628.362z"
          opacity="0.2"
          transform="translate(518.96 115.064)"
        ></path>
        <g opacity="0.8">
          <path
            fill="#3C48FA"
            fillRule="nonzero"
            d="M408.146 336.908c.73.393 1.398.889 1.984 1.473a6.627 6.627 0 00-1.71-1.398 2.417 2.417 0 01-.274-.075zm-172.311-124.65c.174-.2.337-.412.511-.649l.175-.237.537-.774.15-.224.598-.949.088-.15a54.08 54.08 0 002.808-5.34c.028-.078.061-.153.1-.226.187-.411.374-.823.549-1.248l.15-.349c.174-.387.336-.761.486-1.148l.187-.437c.15-.362.287-.736.437-1.11l.187-.475.412-1.098.187-.512c.138-.362.263-.724.387-1.098.063-.162.125-.337.175-.5.137-.386.262-.786.387-1.172l.15-.437.486-1.56.188-.662.262-.898c.075-.275.137-.55.212-.824l.187-.711c.075-.3.15-.587.212-.874l.15-.624c.075-.3.137-.611.2-.91l.112-.55c.075-.312.125-.612.187-.924.063-.312.063-.312.088-.474.024-.162.1-.624.15-.936.05-.312 0-.274.062-.412.062-.137.087-.636.124-.948a2.103 2.103 0 000-.275c.22-1.656.22-3.335 0-4.992v-.112a5.139 5.139 0 00-.998-2.496c-4.867-5.616-9.372 1.71-9.372 1.71l-9.66 15.562s-24.66-30.688-33.846-40.947a29.441 29.441 0 00-21.216-9.871 120.736 120.736 0 00-20.392 3.394 22.28 22.28 0 006.939-7.275c2.945-4.83 8.461-20.03 9.273-22.252 1.173-3.233-1.248-4.031-2.197-4.219a9.625 9.625 0 005.366-.798c.32-.122.644-.226.974-.312.11.078.24.125.374.137a.822.822 0 00.724-.35 5.734 5.734 0 003.944-1.797 4.07 4.07 0 001.248-3.42.843.843 0 000-.174v-1.934c0-.262 0-.5.075-.737a.642.642 0 000-.124c.237-1.922.486-3.008-2.297-4.194 1.423-1.098 8.087-1.572 8.637-3.744.748-2.92-2.734-2.021-6.053-1.472-3.557.599-9.922 1.51-12.343 1.86h-.524c-.83.04-1.65.2-2.434.474-5.304 1.672-6.402 8.623-5.865 10.533a1.396 1.396 0 00-1.922.536c-3.744 6.74-9.235 14.827-15.538 18.72-8.624 5.38-22.838-4.68-27.456-5.616l-1.036-.387a13.893 13.893 0 00-1.572-.649l-.861-.262-4.643-1.81c-1.984-.835-3.482-1.522-3.482-1.522a13.388 13.388 0 01-1.248-10.67l.187-.674a15.499 15.499 0 00-3.182-14.677l-6.59-7.488a1.577 1.577 0 000-.723l-.274.361-3.906-4.43-2.047-2.321C95.946 50.068 58.668 57.157 55.736 46.05c-1.436-5.454 6.364-8.886 4.68-14.976-3.27-11.981-14.04-6.952-21.828-12.33C27.681 11.254 30.863.472 22.202.023 7.937-.652 12.829 15.535 9.535 22.911 6.04 30.724 1.123 38.087.66 42.455c-2.808 26.071 23.226 24.012 28.567 29.229 5.94 5.803-8.836 26.133 11.744 28.704 5.104.648 6.64 3.818 8.436 7.188-3.47-2.409-1.972 2.933-3.07 4.206-7.575 8.836-13.079 15.887-16.973 26.37-3.27 8.836 3.033 15.65 11.72 17.085 11.78 1.947 19.967-9.572 30.638-1.485 6.976 5.304 21.852 40.423 28.454 36.067 4.068 10.109 21.69 5.491 26.12 4.144a41.578 41.578 0 009.985 3.594c1.085.3 1.81.462 1.822.462 10.146 2.496 24.96 4.992 40.46 7.2a43.879 43.879 0 00.125 5.292v.1c1.123 13.453 7.7 25.883 5.928 44.266-.587 6.24-6.24 10.958 1.11 13.728 1.473.55 4.156 1.248 7.014 1.935l1.073.25 4.244.948 2.758.586 1.734.387 3.532.861c1.772.437 3.532.874 5.217 1.248 3.37.7 6.44 1.061 8.736.45a5.491 5.491 0 001.048-.387 4.288 4.288 0 002.172-2.309c1.435-3.457-.986-5.142-4.156-5.866-7.026-1.584-18.258-9.56-19.78-12.105 0 0 5.178-4.418 5.765-6.864.986-4.119.699-29.428 1.697-38.114.587-5.142 1.722-12.156-2.496-15.987-5.167-4.642-38.214-18.37-38.214-18.37l5.804-2.759a12.581 12.581 0 0113.528 1.86 72.477 72.477 0 009.497 6.627 63.087 63.087 0 0119.469 18.383c3.12 4.518 8.549 9.884 8.736 10.758a9.984 9.984 0 004.842 4.717c.219.09.444.16.674.212l.287.075c.262 0 .524.087.799.112h.162c.27.019.541.019.811 0h.188c.337-.03.67-.088.998-.174h.187c.374-.1.74-.226 1.098-.375a3.72 3.72 0 00.624-.337l.113-.087c.174-.125.35-.25.524-.4l.175-.15.486-.46.187-.213c.163-.175.325-.35.487-.55l.088-.249zm-96.42-63.985a251.749 251.749 0 00-11.745 4.106c-3.344-2.309-4.992-5.815-6.115-9.76a31.193 31.193 0 0017.86 5.654zm-37.091-32.597zm-.4 4.155a5.857 5.857 0 00.001 0 8.243 8.243 0 01-.001 0zm-18.62-4.842l-.487-.35.487.35zm-15.9-19.793c.213.35.425.699.6 1.048-.163-.35-.387-.699-.6-1.048zm-1.934-2.571l-.836-1.036.836 1.036c.412.512.824 1.036 1.248 1.547-.424-.549-.836-1.035-1.248-1.547zm-2.983-4.306c.188.387.387.75.612 1.124.225.374.474.723.736 1.085a19.065 19.065 0 01-.736-1.085 12.291 12.291 0 01-.612-1.124zm.362 15.288zm1.248 3.058a7.125 7.125 0 01-.511-.874c.15.29.322.57.511.837v.037zm7.089 1.086s-2.496 3.744-5.566.711c3.008 2.958 5.553-.749 5.553-.749l.013.038zm.15 10.383l-17.984 13.728s11.993-13.004 10.37-16.773c3.558-.562 7.127-2.221 8.737-5.84v-.15a16.737 16.737 0 007.176 3.993c.619.166 1.218.4 1.785.699a7.36 7.36 0 00-.787-.362c-4.418.65-9.31 4.668-9.31 4.668l.013.037zm11.082-3.769c-.212-.137-.424-.274-.637-.387l.637.387zm11.394 8.823c.775.1 1.56.1 2.334 0-.78.09-1.57.077-2.346-.037l.012.037zm3.058-.162a9.105 9.105 0 003.22-1.435 9.11 9.11 0 01-3.233 1.398l.013.037zm463.994-36.229c-1.473-2.746-14.59-23.113-24.96-17.684-8.137 4.268-8.225 14.302-8.175 16.224v.337s-9.185 8.873-10.683 18.72c-1.31-3.17-4.418-7.488-11.394-5.342-10.595 3.183-42.432 16.312-42.432 16.312a24.224 24.224 0 00-3.47.112 6.774 6.774 0 000-1.61c.168-.566.223-1.16.163-1.747a4.859 4.859 0 00-.087-.587c.686-3.744 4.255-6.976 9.697-13.64 0 0 0-2.883-3.17-.637s-7.888 9.16-7.888 9.16l-1.934-12.867a1.36 1.36 0 00-2.671 0v.075c-.324 2.82-.312 11.856-.312 11.856l-9.06-11.544s-2.047-.649-.712 2.746a57.64 57.64 0 004.843 8.237l-7.488-3.47s-.824.774.449 2.16a18.886 18.886 0 003.37 2.67 16.73 16.73 0 00-1.249 8.324c-1.784-1.86-5.553-5.778-6.027-6.24-.475-.462-1.161.462-1.049 1.635a59.063 59.063 0 00-13.478-13.428c-13.017-9.26-50.98-29.154-50.98-29.154l9.372-15.15s4.417-7.077-2.559-8.874a4.99 4.99 0 00-2.57.188h-.113a18.993 18.993 0 00-4.38 2.184l-.225.15c-.262.162-.512.349-.774.523l-.324.225-.75.537-.374.287c-.25.175-.486.362-.736.561l-.424.325-.7.574-.46.387-.687.574-.512.45-.636.56-.662.6-.5.462-1.147 1.098-.337.324-.824.824-.374.387-.787.799c-.112.137-.237.262-.361.399-.125.137-.512.537-.762.824-.122.114-.24.235-.35.362l-.76.86-.312.35c-.263.3-.525.6-.774.911l-.25.3-.823.986-.163.212-.923 1.173c-.936 1.248-1.772 2.409-2.496 3.544l-.1.15c-.2.312-.387.624-.562.923l-.137.238c-.15.262-.287.524-.424.786a1.9 1.9 0 00-.138.274 20.28 20.28 0 00-.349.712l-.125.262c-.1.224-.187.45-.262.661l-.1.262a6.788 6.788 0 00-.187.612 1.558 1.558 0 00-.062.225c0 .212-.088.411-.125.611.006.05.006.1 0 .15-.018.224-.018.45 0 .674v.087c.033.42.1.838.2 1.248 0 .137.074.262.112.4.078.272.174.538.287.798 0 .125.112.237.162.35.05.112.275.486.424.711l.163.237c.209.27.438.525.686.761a9.717 9.717 0 006.24 2.16c.861-.175 7.863 2.233 13.13 2.995 1.135.162 0 9.984 1.821 11.232 9.71 6.714 24.124 18.233 36.092 26.644a30.5 30.5 0 00-9.335 0c-8.91 1.773-46.176 4.019-46.176 4.019-2.009 1.41-.274 9.335-.274 9.335l-3.507-1.523c-4.543-2.496-11.57-7.675-14.527-11.993-1.785-2.608-6.527-3.008-9.148-.474-4.38 4.268 5.84 13.728 10.908 21.216a93.689 93.689 0 008.474 9.984c5.204 5.653 12.83-3.956 12.83-3.956 17.06-.762 31.798-1.323 39.735-1.623l6.24-.224a229.4 229.4 0 0115.763 18.433c.749 6.24 1.972 15.038 3.744 24.236 3.893 19.718 36.766 14.077 37.702 4.38 0 0 7.675 2.297 13.628-1.185 3.444-2.022 9.81-7.276 17.21-13.803a136.206 136.206 0 0026.994-16.374c11.444-8.96 21.94-19.743 18.246-26.058a5.665 5.665 0 00-1.86-1.935c-4.605-4.83-5.628-6.24-5.765-6.54a.544.544 0 00.087-.086c2.084-2.322 12.23-9.984 12.23-9.984s.487 2.134 4.73.636c5.417-1.897 11.494-9.223 5.491-10.982.275-.125 8.424-3.882 6.24-10.895.025.05 4.518-2.122 1.748-7.301zm-121.53 27.131h-.275.274z"
            opacity="0.2"
          ></path>
        </g>
        <path
          fill="url(#cb0cgropzbe)"
          fillRule="nonzero"
          d="M207.016 361.795h55.885v55.885h-55.885z"
          transform="rotate(19.69 234.959 389.737)"
        ></path>
        <path
          fill="url(#km2n4u2n8bf)"
          fillRule="nonzero"
          d="M79.186 266.234l-2.471 17.41-17.423-2.471z"
        ></path>
        <path
          fill="url(#vcbs4o9vibg)"
          fillRule="nonzero"
          d="M501.234 371.902l17.959-24.997 24.985 17.971z"
        ></path>
        <circle cx="360" cy="424" r="37" fill="url(#pid0znbrmbh)"></circle>
        <path
          fill="url(#7t3nysg65bi)"
          d="M264 321c-41.007 0-74.328-32.91-74.99-73.76L189 246h37.323l-.001.178c0 20.503 16.455 37.164 36.88 37.495l.62.005H264V321z"
        ></path>
        <path fill="url(#fcftaxk9rbj)" d="M88 412v66h66z"></path>
        <path
          fill="url(#wme971wqpbk)"
          d="M513.166 237.166c13.899 0 25.166-11.267 25.166-25.166H488c0 13.899 11.267 25.166 25.166 25.166z"
        ></path>
        <path fill="url(#7s2d4m4ctbl)" d="M27 246v57l32-28.5z"></path>
        <path fill="url(#9gknqpqa8bm)" d="M90 246v57l31-28.5z"></path>
        <path fill="url(#utgyokfzwbn)" d="M58 246v57l31-28.5z"></path>
        <path fill="url(#fu9ir4ow3bo)" d="M216 61h48v48h-48z"></path>
      </g>
    </svg>
  );
}

export default Icon;
